import React, { useState, useEffect, useRef, useMemo } from 'react';
import OfertaEconomica19 from '../components/OfertaEconomica19';
import useEmpresas from '../hooks/useEmpresas';
import './generador-oferta19.scss';
import { Container, Modal } from 'reactstrap';
import { FaUser } from 'react-icons/fa';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { obtenerConfiguracionAccesos } from '../services/adminService';
import { hasGeneradorAccess } from '../components/planPermissions';

/* ─── Constantes ─────────────────────────────────────────── */

const MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','setiembre','octubre','noviembre','diciembre'];
const TIPOS_DOC = ['DNI', 'Carnet de Extranjería', 'Pasaporte', 'Cédula Diplomática'];

const PROCEDIMIENTOS = [
  { id: 'licitacion_publica',           label: 'Licitación Pública',           icon: '🏛️', color: '#3b82f6', bg: '#eff6ff',
    folder: 'Licitacion_Publica',
    objetos: [
      { id: 'Bienes', label: 'Bienes',  icon: '📦', color: '#3b82f6', bg: '#eff6ff' },
      { id: 'Obra',   label: 'Obra',    icon: '🏗️', color: '#0ea5e9', bg: '#f0f9ff', disponible: false },
    ],
  },
  { id: 'licitacion_publica_abreviada', label: 'Licitación Pública Abreviada', icon: '📋', color: '#6366f1', bg: '#eef2ff',
    folder: 'Licitacion_Publica_Abreviada',
    objetos: [
      { id: 'Bienes', label: 'Bienes',  icon: '📦', color: '#6366f1', bg: '#eef2ff' },
      { id: 'Obra',   label: 'Obra',    icon: '🏗️', color: '#8b5cf6', bg: '#f5f3ff', disponible: false },
    ],
  },
  { id: 'concurso_publico',             label: 'Concurso Público',             icon: '🏆', color: '#f59e0b', bg: '#fffbeb',
    folder: 'Concurso_Publico',
    objetos: [
      { id: 'Servicios',              label: 'Servicios',              icon: '⚙️', color: '#f59e0b', bg: '#fffbeb' },
      { id: 'Consultoria_de_Obra',    label: 'Consultoría de Obra',    icon: '📐', color: '#d97706', bg: '#fef3c7', disponible: false },
      { id: 'Consultoria_en_General', label: 'Consultoría en General', icon: '📊', color: '#d97706', bg: '#fef3c7', disponible: false },
    ],
  },
  { id: 'concurso_publico_abreviado',   label: 'Concurso Público Abreviado',   icon: '📝', color: '#10b981', bg: '#ecfdf5',
    folder: 'Concurso_Publico_Abreviado',
    objetos: [
      { id: 'Servicios',              label: 'Servicios',              icon: '⚙️', color: '#10b981', bg: '#ecfdf5' },
      { id: 'Consultoria_de_Obra',    label: 'Consultoría de Obra',    icon: '📐', color: '#059669', bg: '#d1fae5', disponible: false },
      { id: 'Consultoria_General',    label: 'Consultoría en General', icon: '📊', color: '#059669', bg: '#d1fae5' },
    ],
  },
  { id: 'comparacion_precios',          label: 'Comparación de Precios',       icon: '💰', color: '#ec4899', bg: '#fdf2f8', disponible: false },
  { id: 'subasta_inversa',              label: 'Subasta Inversa Electrónica',  icon: '⚡', color: '#f97316', bg: '#fff7ed',
    folder: 'Subasta_Inversa_Electronica', disponible: false,
  },
];

/* Modalidad de participación — común a todos los procedimientos.
   El consorcio aún no está habilitado (plantillas en elaboración). */
const MODALIDADES_PARTICIPACION = [
  { id: 'individual', label: 'Individual', descripcion: 'Postulas por tu cuenta', icon: <FaUser />, color: '#0d9488', bg: '#e7faf6' },
  { id: 'consorcio',  label: 'Consorcio', descripcion: 'Postulas junto a otros postores', icon: '🤝', color: '#7c3aed', bg: '#f5f3ff', disponible: false },
];

const GRUPOS_ANEXO = {
  admision:    'Documentos de admisión de oferta',
  evaluacion:  'Factores de evaluación',
  calificacion:'Requisitos de calificación',
  bonificacion:'Bonificación',
};

/* Opciones deshabilitadas ("Próximamente") en todos los procedimientos. */
const SISTEMA_ENTREGA_OFF = ['Llave en mano con mantenimiento'];
const MODALIDAD_PAGO_OFF  = ['Esquema Mixto'];
/* Opciones aún no habilitadas solo en Licitación Pública Abreviada (temporal). */
const LPA_SISTEMA_ENTREGA_OFF = ['Llave en mano con mantenimiento'];
const LPA_MODALIDAD_PAGO_OFF  = ['Precios Unitarios', 'Esquema Mixto'];

const ANEXOS = [
  { id: 'anexo1',  label: 'Anexo 1 — Declaración Jurada de datos del postor', descripcion: 'Datos del postor o representante legal',                 grupo: 'admision'     },
  { id: 'anexo2',  label: 'Anexo 2 — Pacto de Integridad',                    descripcion: 'Compromiso de integridad en el proceso',                 grupo: 'admision'     },
  { id: 'anexo3',  label: 'Anexo 3 — Declaración Jurada',                     descripcion: 'Declaración de impedimentos y normativa',                grupo: 'admision'     },
  { id: 'anexo4',  label: 'Anexo 4 — Promesa de Consorcio',                   descripcion: 'Acuerdo de consorcio entre postores',                    grupo: 'admision'     },
  { id: 'anexo5',  label: 'Anexo 5 — Desafectación de Impedimento',           descripcion: 'Declaración de desafectación de impedimento',            grupo: 'admision'     },
  { id: 'anexo6',  label: 'Anexo 6 — Oferta Económica',                       descripcion: 'Disponible en Suma Alzada y Precios Unitarios',          grupo: 'admision'     },
  { id: 'anexo11', label: 'Anexo 11 — Experiencia del Postor en la Especialidad', descripcion: 'Listado de contratos que acreditan la experiencia',  grupo: 'calificacion' },
  { id: 'anexo12', label: 'Anexo 12 — Plazo de Entrega',                      descripcion: 'Solo disponible cuando el sistema de entrega es No aplica', grupo: 'evaluacion' },
  { id: 'anexo19', label: 'Anexo 19 — Experiencia de la Persona Clave',        descripcion: 'Listado de la persona clave propuesta y su experiencia',  grupo: 'evaluacion' },
  { id: 'anexo16', label: 'Anexo 16 — Bonificación 5% MYPE',                  descripcion: 'Para postores con condición MYPE acreditada',            grupo: 'bonificacion' },
  { id: 'anexo17', label: 'Anexo 17 — Bonificación 5% MYPE',                  descripcion: 'Para postores con condición MYPE acreditada',            grupo: 'bonificacion' },
];

/* El Anexo 16 varía según el procedimiento: en Concurso Público Abreviado de
   Servicios corresponde a la bonificación del 10% por provincias colindantes
   (servicios prestados fuera de Lima y Callao), no a la del 5% MYPE. En
   Concurso Público Abreviado de Consultoría en General el Anexo 16 es la
   experiencia y formación académica del personal clave (usa el bucle
   {#personal}), y la bonificación MYPE corresponde al Anexo 17. */
const ANEXOS_OVERRIDE = {
  'concurso_publico_abreviado/Servicios': {
    anexo16: { label: 'Anexo 16 — Bonificación 10% por provincias colindantes', descripcion: 'Para servicios prestados fuera de la provincia de Lima y Callao' },
    anexo19: { label: 'Anexo 19 — Experiencia y Formación Académica del Personal Clave', descripcion: 'Personal clave propuesto: experiencia y formación académica' },
  },
  'concurso_publico_abreviado/Consultoria_General': {
    anexo16: { label: 'Anexo 16 — Experiencia y Formación Académica del Personal Clave', descripcion: 'Personal clave propuesto: experiencia y formación académica', grupo: 'evaluacion' },
  },
};
const getAnexosUI = (procedimiento, objeto) => {
  const ov = ANEXOS_OVERRIDE[`${procedimiento}/${objeto}`];
  return ov ? ANEXOS.map(a => (ov[a.id] ? { ...a, ...ov[a.id] } : a)) : ANEXOS;
};

const COLUMNAS_EXP = [
  { key: 'cliente',           label: 'Cliente' },
  { key: 'objeto_contrato',   label: 'Objeto del contrato' },
  { key: 'contrato',          label: 'N° contrato o comprobante de pago' },
  { key: 'fecha_contrato',    label: 'Fecha del contrato o CP' },
  { key: 'fecha_conformidad', label: 'Fecha de la conformidad (de ser el caso)' },
  { key: 'experiencia_de',    label: 'Experiencia proveniente de' },
  { key: 'moneda',            label: 'Moneda' },
  { key: 'importe',           label: 'Importe' },
  { key: 'tipo_cambio',       label: 'Tipo de cambio venta' },
  { key: 'monto_acumulado',   label: 'Monto facturado acumulado' },
];
const FILA_EXP_0 = COLUMNAS_EXP.reduce((o, c) => ({ ...o, [c.key]: c.key === 'moneda' ? 'Soles' : '' }), {});

const COLUMNAS_PERS = [
  { key: 'puesto',    label: 'Denominación del puesto, cargo y/o posición' },
  { key: 'nombres',   label: 'Nombres y apellidos' },
  { key: 'documento', label: 'Documento de identidad' },
  { key: 'tiempo',    label: 'Tiempo de experiencia específica (años, meses y días)' },
];
/* En Concurso Público Abreviado de Servicios (Anexo 19) y de Consultoría en
   General (Anexo 16) la tabla del personal clave incluye además la formación
   académica. */
const COLUMNAS_PERS_CPA_SERVICIOS = [
  { key: 'puesto',                label: 'Denominación del puesto, cargo y/o posición' },
  { key: 'nombres',               label: 'Nombres y apellidos' },
  { key: 'documento',             label: 'Documento de identidad' },
  { key: 'institucion_educativa', label: 'Universidad o institución educativa' },
  { key: 'grado_o_titulo',        label: 'Grado o título profesional' },
  { key: 'tiempo',                label: 'Tiempo de experiencia específica (años, meses y días)' },
];
const getColumnasPers = (procedimiento, objeto) =>
  procedimiento === 'concurso_publico_abreviado' && (objeto === 'Servicios' || objeto === 'Consultoria_General')
    ? COLUMNAS_PERS_CPA_SERVICIOS : COLUMNAS_PERS;
/* Anexo del personal clave según el procedimiento: normalmente el Anexo 19,
   salvo en Concurso Público Abreviado de Consultoría en General, donde la
   experiencia y formación del personal clave se registra en el Anexo 16. */
const getAnexoPersonalClave = (procedimiento, objeto) =>
  procedimiento === 'concurso_publico_abreviado' && objeto === 'Consultoria_General' ? 'anexo16' : 'anexo19';
const FILA_PERS_0 = COLUMNAS_PERS_CPA_SERVICIOS.reduce((o, c) => ({ ...o, [c.key]: '' }), {});

// Anexo 6: cada ítem de la oferta económica. Puede haber varios.
//  · Suma Alzada     → se usa { concepto, precio }.
//  · Precios Unitarios → se usa { concepto, cantidad, precio_unitario }; el
//    precio total del ítem se calcula (cantidad × precio_unitario).
const FILA_ANEXO6_0 = { concepto: '', precio: '', cantidad: '', precio_unitario: '', unidad: '' };

const FORM_PJ_0 = { razon_social: '', ruc: '', telefono: '', domicilio_legal: '', correo_notificacion: '', sede_registral: '', numero_partida_registral: '', numero_asiento: '', ciudad: '', nombre: '', tipo_documento: 'DNI', numero_documento: '', es_mype: 'NO' };
const FORM_PN_0 = { nombre_completo: '', tipo_documento: 'DNI', numero_documento: '', ruc: '', telefono: '', domicilio: '', correo: '', ciudad: '', es_mype: 'NO' };
const FORM_OFERTA_0 = { nomenclatura: '', nombre: '', tipo_documento: 'DNI', numero_documento: '', es_mype: 'SI', fecha_envio: new Date().toISOString().split('T')[0], plazo: '', plazo_instalacion: '', concepto: '', precio: '', oferta_letras: '', tipo_moneda: 'Soles', gastos_generales_pct: '', utilidad_pct: '' };
// Todos los anexos inician sin marcar; el usuario elige cuáles generar.
const SEL_DEFAULT = {};

/* Convierte un monto a letras en formato peruano: "Doce mil quinientos con 00/100" */
const numeroALetras = (num) => {
  if (isNaN(num) || num < 0) return '';
  const UNIDADES = ['', 'un', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve'];
  const DIECES   = ['diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve'];
  const DECENAS  = ['', 'diez', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];
  const CENTENAS = ['', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos'];

  const tresDigitos = (n) => {
    if (n === 0) return '';
    if (n === 100) return 'cien';
    const c = Math.floor(n / 100), resto = n % 100;
    let txt = c ? CENTENAS[c] : '';
    if (resto) {
      let parte;
      if (resto < 10) parte = UNIDADES[resto];
      else if (resto < 20) parte = DIECES[resto - 10];
      else if (resto === 20) parte = 'veinte';
      else if (resto < 30) parte = resto === 21 ? 'veintiún' : 'veinti' + UNIDADES[resto - 20];
      else {
        const d = Math.floor(resto / 10), u = resto % 10;
        parte = DECENAS[d] + (u ? ' y ' + UNIDADES[u] : '');
      }
      txt = txt ? `${txt} ${parte}` : parte;
    }
    return txt;
  };

  let entero = Math.floor(num);
  let dec = Math.round((num - entero) * 100);
  if (dec === 100) { entero += 1; dec = 0; }

  let letras = '';
  if (entero === 0) letras = 'cero';
  else {
    const millones = Math.floor(entero / 1000000);
    const miles    = Math.floor((entero % 1000000) / 1000);
    const resto    = entero % 1000;
    if (millones) letras += millones === 1 ? 'un millón' : `${tresDigitos(millones)} millones`;
    if (miles)    letras += `${letras ? ' ' : ''}${miles === 1 ? '' : tresDigitos(miles) + ' '}mil`;
    if (resto)    letras += `${letras ? ' ' : ''}${tresDigitos(resto)}`;
  }
  letras = letras.charAt(0).toUpperCase() + letras.slice(1);
  return `${letras} con ${String(dec).padStart(2, '0')}/100`;
};

/* Redondeo a 2 decimales, medio hacia arriba: si el tercer decimal es menor a 5
   el valor permanece igual; si es 5 o mayor, se incrementa el segundo decimal. */
const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

const formatFecha  = (str) => { if (!str) return ''; const [y,m,d] = str.split('-').map(Number); return `${d} de ${MESES[m-1]} de ${y}`; };
const splitFecha   = (str) => { if (!str) return { dias: '', mes: '', anio: '' }; const [y,m,d] = str.split('-').map(Number); return { dias: String(d).padStart(2,'0'), mes: MESES[m-1], anio: String(y) }; };
const getTemplatePath = (folder, objeto, tipo, anexoId, llaveMano = false, modalidad = 'Suma Alzada') => {
  let fileId = anexoId;
  if (anexoId === 'anexo6') fileId = modalidad === 'Precios Unitarios' ? 'anexo6_PRECIOS_UNITARIOS' : 'anexo6_SUMA_ALZADA';
  else if (anexoId === 'anexo12' && llaveMano) fileId = 'anexo12_llave_mano';
  const parts = ['/templates', folder, objeto, tipo, `${fileId}.docx`].filter(Boolean);
  return parts.join('/');
};

/* En Licitación Pública / Licitación Pública Abreviada / Concurso Público
   Abreviado con sistema de entrega "Llave en mano" el Anexo 12 usa la plantilla
   anexo12_llave_mano.docx, que suma el plazo de entrega de bienes y el de
   instalación (total_dias). */
const esAnexo12LlaveMano = (procedimiento, sistemaEntrega) =>
  (procedimiento === 'licitacion_publica' || procedimiento === 'licitacion_publica_abreviada' || procedimiento === 'concurso_publico_abreviado') &&
  sistemaEntrega === 'Llave en mano';

/* ─── Componentes base ───────────────────────────────────── */

/* Une varios .docx incrustando cada anexo adicional como altChunk en el
   primero. Word integra los chunks al abrir el archivo conservando notas
   al pie, numeración y estilos de cada plantilla original. Entre anexos
   se insertan saltos de sección con el sectPr de cada plantilla, de modo
   que cada anexo mantiene su propia orientación y tamaño de página. */
const mergeDocxAltChunks = (uint8Docs) => {
  const zip = new PizZip(uint8Docs[0]);
  let docXml = zip.file('word/document.xml').asText();
  let relsXml = zip.file('word/_rels/document.xml.rels').asText();
  let contentTypes = zip.file('[Content_Types].xml').asText();

  const extraerSectPr = (xml) => {
    const start = xml.lastIndexOf('<w:sectPr');
    if (start === -1) return { xml: '', start: -1, end: -1 };
    let end = xml.indexOf('</w:sectPr>', start);
    end = end !== -1 ? end + '</w:sectPr>'.length : xml.indexOf('>', start) + 1;
    return { xml: xml.slice(start, end), start, end };
  };
  // los headers/footers de los chunks no existen en las relaciones del documento base
  const limpiarSectPr = (s) => s.replace(/<w:(headerReference|footerReference)[^>]*\/>/g, '');

  let maxRid = 0;
  relsXml.replace(/Id="rId(\d+)"/g, (m, n) => { maxRid = Math.max(maxRid, parseInt(n, 10)); return m; });

  const base = extraerSectPr(docXml);
  if (base.start !== -1) docXml = docXml.slice(0, base.start) + docXml.slice(base.end);

  let insertXml = '';
  let prevSectPr = base.xml; // sección del contenido que precede al siguiente salto
  uint8Docs.slice(1).forEach((bytes, i) => {
    const rid = `rId${maxRid + 1 + i}`;
    const partName = `word/anexo_chunk${i + 1}.docx`;
    zip.file(partName, bytes);
    relsXml = relsXml.replace('</Relationships>',
      `<Relationship Id="${rid}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/aFChunk" Target="anexo_chunk${i + 1}.docx"/></Relationships>`);
    contentTypes = contentTypes.replace('</Types>',
      `<Override PartName="/${partName}" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document"/></Types>`);
    insertXml += `<w:p><w:pPr>${prevSectPr}</w:pPr></w:p><w:altChunk r:id="${rid}"/>`;
    let chunkSectPr = '';
    try { chunkSectPr = extraerSectPr(new PizZip(bytes).file('word/document.xml').asText()).xml; } catch { /* usa el del base */ }
    prevSectPr = chunkSectPr ? limpiarSectPr(chunkSectPr) : base.xml;
  });

  docXml = docXml.replace('</w:body>', `${insertXml}${prevSectPr}</w:body>`);

  zip.file('word/document.xml', docXml);
  zip.file('word/_rels/document.xml.rels', relsXml);
  zip.file('[Content_Types].xml', contentTypes);
  return zip.generate({ type: 'uint8array' });
};

const InputField = ({ label, name, value, onChange, placeholder, type = 'text', icon, colSpan, disabled, required }) => (
  <div className={colSpan === 2 ? 'go-col2' : ''}>
    <label className="go-field-label">
      {label}{required && <span style={{ color: '#ef4444', marginLeft: 3 }}>*</span>}
    </label>
    <div style={{ position: 'relative' }}>
      {icon && <span style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', fontSize: '0.9rem', pointerEvents: 'none', zIndex: 1 }}>{icon}</span>}
      <input
        type={type} name={name} value={value} onChange={onChange}
        placeholder={placeholder} disabled={disabled}
        className="go-input"
        style={{ paddingLeft: icon ? 36 : 12 }}
        onFocus={e => { if (!disabled) { e.target.style.borderColor = '#0d9488'; e.target.style.boxShadow = '0 0 0 3px rgba(13,148,136,0.1)'; }}}
        onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
      />
    </div>
  </div>
);

const SelectInput = ({ label, name, value, onChange, options, icon, colSpan, required }) => (
  <div className={colSpan === 2 ? 'go-col2' : ''}>
    <label className="go-field-label">
      {label}{required && <span style={{ color: '#ef4444', marginLeft: 3 }}>*</span>}
    </label>
    <div style={{ position: 'relative' }}>
      {icon && <span style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', fontSize: '0.9rem', pointerEvents: 'none', zIndex: 1 }}>{icon}</span>}
      <select name={name} value={value} onChange={onChange} className="go-input go-select" style={{ paddingLeft: icon ? 36 : 12 }}>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  </div>
);

const FormGroup = ({ title, children }) => (
  <div style={{ marginBottom: '0.25rem' }}>
    {title && (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>{title}</span>
        <div style={{ flex: 1, height: 1, background: '#f1f5f9' }} />
      </div>
    )}
    <div className="go-grid">
      {children}
    </div>
  </div>
);

const SectionBlock = ({ icon, title, subtitle, color = '#0d9488', bg = '#e7faf6' }) => (
  <div className="go-section-block">
    <div style={{ width: 36, height: 36, borderRadius: 9, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', flexShrink: 0 }}>{icon}</div>
    <div>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#111827', lineHeight: 1.3 }}>{title}</div>
      {subtitle && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{subtitle}</div>}
    </div>
  </div>
);

const StepBadge = ({ number, label, active, done }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
    <div style={{
      width: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontWeight: 700, fontSize: '0.78rem', flexShrink: 0, transition: 'all 0.2s',
      background: done ? '#059669' : active ? '#0d9488' : '#e5e7eb',
      color: done || active ? 'white' : '#9ca3af',
      boxShadow: active ? '0 0 0 4px rgba(13,148,136,0.15)' : 'none',
    }}>
      {done ? '✓' : number}
    </div>
    <span className="go-step-label" style={{ fontSize: 13, fontWeight: active ? 700 : 500, color: active ? '#111827' : done ? '#059669' : '#9ca3af' }}>{label}</span>
  </div>
);

/* ═══════════════════════════════════════════════════════════
   MI EMPRESA — REDISEÑO
══════════════════════════════════════════════════════════ */

/* ── Inline SVG icons ── */
const LhIcon = ({ name, size = 20, sw = 1.8 }) => {
  const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: sw, strokeLinecap: 'round', strokeLinejoin: 'round' };
  const paths = {
    building: (<><rect x="4" y="3" width="16" height="18" rx="1.5"/><path d="M8 7h2M8 11h2M8 15h2M14 7h2M14 11h2M14 15h2"/></>),
    user:     (<><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6 8-6s8 2 8 6"/></>),
    phone:    (<path d="M5 4h3l1.5 4.5L7.5 10a12 12 0 0 0 6 6l1.5-2 4.5 1.5V19a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>),
    mail:     (<><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></>),
    pin:      (<><path d="M12 21s-7-5.7-7-11a7 7 0 0 1 14 0c0 5.3-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></>),
    hash:     (<path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18"/>),
    id:       (<><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="M7 16c.5-1.2 1.3-2 2-2s1.5.8 2 2M14 9h4M14 13h4"/></>),
    bank:     (<><path d="M3 9 12 4l9 5M4 9h16M5 9v9M9 9v9M15 9v9M19 9v9M3 21h18"/></>),
    file:     (<><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></>),
    seal:     (<><circle cx="12" cy="9" r="6"/><path d="M9 14.5 8 21l4-2 4 2-1-6.5"/></>),
    check:    (<path d="M20 6 9 17l-5-5"/>),
    save:     (<><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><path d="M17 21v-8H7v8M7 3v5h7"/></>),
    alert:    (<><path d="M12 9v4M12 17h.01"/><path d="M10.3 3.9 2 18a2 2 0 0 0 1.7 3h16.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></>),
    lock:       (<><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></>),
    folder:     (<><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></>),
    calendar:   (<><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>),
    tag:        (<><path d="M20.6 8.34 13.66 1.4A2 2 0 0 0 12.24 1H4a2 2 0 0 0-2 2v8.24a2 2 0 0 0 .59 1.41l6.93 6.94a2 2 0 0 0 2.83 0l8.24-8.24a2 2 0 0 0 0-2.01z"/><circle cx="7.5" cy="7.5" r="1.5"/></>),
    coins:      (<><circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1 1 10.34 18"/><path d="M7 6h1v4"/><path d="m16.71 13.88.7.71-2.82 2.82"/></>),
    arrowLeft:  (<><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></>),
    arrowRight: (<><path d="m5 12 7-7 7 7"/><path d="M5 12h14"/></>),
    download:   (<><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>),
    edit2:      (<><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>),
    close:      (<><path d="M18 6 6 18"/><path d="M6 6l12 12"/></>),
    chevronDown:(<path d="m6 9 6 6 6-6"/>),
    chevronUp:  (<path d="m18 15-6-6-6 6"/>),
    plus:       (<><path d="M12 5v14"/><path d="M5 12h14"/></>),
    clock:      (<><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></>),
    info:       (<><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><path d="M12 8h.01"/></>),
    trash:      (<><path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6"/><path d="M14 11v6"/></>),
  };
  return <svg {...p}>{paths[name]}</svg>;
};

const RE_SCHEMA = {
  juridica: {
    generales: [
      { key: 'razon_social',        label: 'Razón social',           req: true,  icon: 'building', col: 'full', ph: 'Nombre legal de la empresa',         help: 'Tal como figura en tu Ficha RUC de SUNAT.' },
      { key: 'ruc',                 label: 'RUC',                    req: true,  icon: 'hash',                  ph: '20XXXXXXXXX',                          help: 'Empieza con 20. Debe tener 11 dígitos.', kind: 'ruc20' },
      { key: 'telefono',            label: 'Teléfono',               req: true,  icon: 'phone',                 ph: '01-4251234',                            help: 'Fijo o celular de contacto.' },
      { key: 'domicilio_legal',     label: 'Domicilio legal',        req: true,  icon: 'pin',      col: 'full', ph: 'Av. / Jr. / Calle, número, distrito',  help: 'Dirección registrada en tu Ficha RUC.' },
      { key: 'correo_notificacion', label: 'Correo de notificación', req: true,  icon: 'mail',     col: 'full', ph: 'contacto@empresa.com',                 help: 'Aquí llegarán las comunicaciones del proceso.', kind: 'email' },
      { key: 'ciudad',              label: 'Ciudad',                 req: true,  icon: 'pin',                   ph: 'Lima',                                 help: 'Ciudad de la sede principal.' },
    ],
    postor: [
      { key: 'nombre',           label: 'Nombre del representante legal', req: true, icon: 'user', col: 'full', ph: 'Nombres y apellidos del representante', help: 'Representante legal que firmará los documentos.' },
      { key: 'tipo_documento',   label: 'Tipo de documento',             req: true, icon: 'id',   kind: 'select', options: ['DNI', 'Carnet de Extranjería', 'Pasaporte', 'Cédula Diplomática'], help: 'Documento del representante legal.' },
      { key: 'numero_documento', label: 'N° de documento',               req: true, icon: 'hash', ph: 'Ej. 45678912', help: 'Número del documento de identidad.' },
    ],
    registrales: [
      { key: 'sede_registral',           label: 'Sede registral',       req: true, icon: 'bank', ph: 'Lima',     help: 'Oficina de SUNARP donde está inscrita.' },
      { key: 'numero_partida_registral', label: 'N° Partida registral', req: true, icon: 'file', ph: '12345678', help: 'Número de partida electrónica.' },
      { key: 'numero_asiento',           label: 'N° Asiento',           req: true, icon: 'seal', ph: 'A0001',    help: 'Asiento de la inscripción.' },
    ],
  },
  natural: {
    generales: [
      { key: 'nombre_completo',  label: 'Nombre completo',        req: true, icon: 'user',  col: 'full', ph: 'Nombres y apellidos',                   help: 'Tal como figura en tu documento de identidad.' },
      { key: 'tipo_documento',   label: 'Tipo de documento',      req: true, icon: 'id',               kind: 'select', options: ['DNI', 'Carnet de Extranjería', 'Pasaporte', 'Cédula Diplomática'], help: 'Documento con el que te identificas.' },
      { key: 'numero_documento', label: 'N° de documento',        req: true, icon: 'hash',              ph: 'Ej. 45678912',                            help: 'DNI: 8 dígitos.' },
      { key: 'ruc',              label: 'RUC',                    req: true, icon: 'hash',              ph: '10XXXXXXXXX',                              help: 'Si tienes RUC como persona natural (empieza con 10).', kind: 'ruc10' },
      { key: 'telefono',         label: 'Teléfono',               req: true, icon: 'phone',             ph: '999 888 777',                              help: 'Celular o fijo de contacto.' },
      { key: 'domicilio',        label: 'Domicilio legal',        req: true, icon: 'pin',  col: 'full', ph: 'Av. / Jr. / Calle, número, distrito',     help: 'Dirección que figura en tu RUC.' },
      { key: 'correo',           label: 'Correo de notificación', req: true, icon: 'mail', col: 'full', ph: 'tucorreo@correo.com',                      help: 'Aquí llegarán las comunicaciones del proceso.', kind: 'email' },
      { key: 'ciudad',           label: 'Ciudad',                 req: true, icon: 'pin',               ph: 'Lima',                                    help: 'Ciudad donde resides.' },
    ],
  },
};

const reIsValid = (field, val) => {
  if (!val || !val.trim()) return false;
  const v = val.trim();
  if (field.kind === 'email')  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  if (field.kind === 'ruc20')  return /^20\d{9}$/.test(v);
  if (field.kind === 'ruc10')  return /^10\d{9}$/.test(v);
  return true;
};

/* Avisos de la barra de guardar. Los de tono 'warn' se quedan más tiempo en pantalla. */
const RE_TOASTS = {
  nube:        { tono: 'ok',   texto: 'Datos guardados en tu cuenta' },
  local:       { tono: 'warn', texto: 'Guardado en este equipo. No se pudo sincronizar con tu cuenta.' },
  limpio:      { tono: 'ok',   texto: 'Datos borrados de este equipo y de tu cuenta' },
  limpioLocal: { tono: 'warn', texto: 'Datos borrados en este equipo. No se pudo sincronizar con tu cuenta.' },
};

const LhField = ({ field, value, onChange, showErr }) => {
  const filled   = !!(value && value.trim());
  const valid    = reIsValid(field, value || '');
  const showTick = filled && valid;
  const showWarn = filled && !valid && (field.kind === 'email' || field.kind === 'ruc20' || field.kind === 'ruc10');
  const missing  = showErr && field.req && !filled;

  return (
    <div className={`lh-field${field.col === 'full' ? ' lh-col-full' : ''}`}>
      <label className="lh-field-label">
        {field.label}
        {field.req
          ? <span style={{ color: '#dc2626', marginLeft: 3 }}>*</span>
          : <span className="lh-opt">(opcional)</span>
        }
      </label>
      <div className="lh-input-wrap">
        <span className="lh-input-ico"><LhIcon name={field.icon} size={18} /></span>
        {field.kind === 'select' ? (
          <select
            className="lh-field-input lh-field-select"
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            style={missing ? { borderColor: '#dc2626' } : undefined}
          >
            <option value="" disabled>Selecciona…</option>
            {field.options.map(o => <option key={o} value={o}>{o}</option>)}
          </select>
        ) : (
          <input
            className="lh-field-input"
            type="text"
            value={value || ''}
            placeholder={field.ph}
            onChange={e => onChange(e.target.value)}
            style={missing ? { borderColor: '#dc2626' } : undefined}
          />
        )}
        <span className={`lh-valid-tick${showTick ? ' lh-valid-tick--show' : ''}`}>
          <LhIcon name="check" size={16} sw={2.8} />
        </span>
      </div>
      <div className={`lh-field-help${showWarn || missing ? ' lh-field-help--warn' : ''}`}>
        {missing ? 'Este campo es obligatorio.' : showWarn ? `Revisa el formato. ${field.help}` : field.help}
      </div>
    </div>
  );
};

const RegistrarEmpresa = ({ empresas, onSave, onClear, cargando, enLaNube }) => {
  const [tipo, setTipo] = useState(() => {
    try { return localStorage.getItem('lh_tipo') || 'juridica'; } catch { return 'juridica'; }
  });
  const [dataPJ, setDataPJ] = useState(() => ({ ...FORM_PJ_0, ...empresas.PJ }));
  const [dataPN, setDataPN] = useState(() => ({ ...FORM_PN_0, ...empresas.PN }));
  const [saving,     setSaving]     = useState(false);
  const [showErr,    setShowErr]    = useState(false);
  const [limpiando,  setLimpiando]  = useState(false);
  const [confirmando, setConfirmando] = useState(false); // pide confirmar antes de borrar
  const [toast,      setToast]      = useState(null); // null | clave de RE_TOASTS
  const toastTimer = useRef(null);
  const ultimoToast = useRef('nube'); // conserva el texto mientras el aviso se desvanece
  if (toast) ultimoToast.current = toast;
  const vistaToast = RE_TOASTS[ultimoToast.current];
  useEffect(() => () => clearTimeout(toastTimer.current), []);
  // Lo que llega de la cuenta entra al formulario (el formulario está bloqueado mientras carga).
  useEffect(() => { setDataPJ({ ...FORM_PJ_0, ...empresas.PJ }); }, [empresas.PJ]);
  useEffect(() => { setDataPN({ ...FORM_PN_0, ...empresas.PN }); }, [empresas.PN]);
  const [activeStep, setActiveStep] = useState(1);

  const genRef    = useRef(null);
  const postorRef = useRef(null);
  const regRef    = useRef(null);

  const data    = tipo === 'juridica' ? dataPJ : dataPN;
  const setData = tipo === 'juridica' ? setDataPJ : setDataPN;
  const vacio   = tipo === 'juridica' ? FORM_PJ_0 : FORM_PN_0;
  const etiquetaTipo = tipo === 'juridica' ? 'Persona Jurídica' : 'Persona Natural';
  // Solo tiene sentido limpiar si algo se apartó del formulario recién abierto.
  const hayDatos = Object.keys(vacio).some(
    k => String(data[k] == null ? '' : data[k]).trim() !== String(vacio[k]).trim()
  );
  const schema  = RE_SCHEMA[tipo];
  const set     = k => v => setData(d => ({ ...d, [k]: v }));

  useEffect(() => { try { localStorage.setItem('lh_tipo', tipo); } catch {} }, [tipo]);

  const reqFields = useMemo(() => {
    const all = [...schema.generales, ...(schema.postor || []), ...(schema.registrales || [])];
    return all.filter(f => f.req);
  }, [tipo]);

  const filledReq  = reqFields.filter(f => reIsValid(f, data[f.key] || '')).length;
  const pct        = reqFields.length > 0 ? Math.round((filledReq / reqFields.length) * 100) : 0;
  const remaining  = reqFields.length - filledReq;
  const genDone    = schema.generales.filter(f => f.req).every(f => reIsValid(f, data[f.key] || ''));
  const postorDone = (schema.postor || []).filter(f => f.req).every(f => reIsValid(f, data[f.key] || ''));

  const steps = tipo === 'juridica'
    ? [
        { n: 1, t: 'Tipo de participante',    s: 'Persona Jurídica',        done: true,        ref: null       },
        { n: 2, t: 'Datos generales',          s: 'Información principal',   done: genDone,     ref: genRef     },
        { n: 3, t: 'Representante legal',      s: 'Datos del postor',        done: postorDone,  ref: postorRef  },
        { n: 4, t: 'Datos registrales',        s: 'Inscripción SUNARP',      done: false,       ref: regRef     },
      ]
    : [
        { n: 1, t: 'Tipo de participante', s: 'Persona Natural',       done: true,    ref: null   },
        { n: 2, t: 'Datos generales',       s: 'Información personal', done: genDone, ref: genRef },
      ];

  const scrollToRef = (ref, n) => {
    setActiveStep(n);
    if (ref && ref.current) ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const mostrarToast = (clave) => {
    setToast(clave);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), RE_TOASTS[clave].tono === 'warn' ? 6000 : 3000);
  };

  // Borra los datos del tipo abierto: formulario, copia del navegador y copia de la cuenta.
  const handleClear = async () => {
    if (limpiando) return;
    setLimpiando(true);
    setToast(null);
    setShowErr(false);
    setData({ ...vacio });
    const sincronizado = await onClear(tipo === 'juridica' ? 'PJ' : 'PN');
    setLimpiando(false);
    setConfirmando(false);
    mostrarToast(sincronizado ? 'limpio' : 'limpioLocal');
  };

  const handleSave = async () => {
    if (saving) return;
    if (remaining > 0) {
      setShowErr(true);
      if (genRef.current) genRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    setSaving(true);
    setToast(null);
    const sincronizado = await onSave(tipo === 'juridica' ? 'PJ' : 'PN', { ...data });
    setSaving(false);
    mostrarToast(sincronizado ? 'nube' : 'local');
  };

  return (
    <fieldset disabled={cargando || saving || limpiando} className="lh-fieldset"><div className="lh-layout">

      {/* ── ASIDE ── */}
      <aside>
        <div className="lh-aside-sticky">

          <div className="lh-prog-card">
            <div className="lh-prog-head">
              <span className="lh-prog-label">Perfil completado</span>
              <span className="lh-prog-pct">{pct}%</span>
            </div>
            <div className="lh-prog-track">
              <div className="lh-prog-fill" style={{ width: pct + '%' }} />
            </div>
            <p className="lh-prog-note">
              {remaining > 0
                ? <><b style={{ color: 'white' }}>{remaining}</b> {remaining === 1 ? 'campo obligatorio pendiente' : 'campos obligatorios pendientes'}</>
                : <span style={{ color: 'white', fontWeight: 700 }}>¡Todo listo para guardar! ✓</span>
              }
            </p>
          </div>

          <div className="lh-stepper">
            {steps.map((st, i) => (
              <div key={st.n}
                   className={`lh-step${activeStep === st.n ? ' lh-step--active' : ''}${st.done ? ' lh-step--done' : ''}`}
                   onClick={() => scrollToRef(st.ref, st.n)}
              >
                <div className="lh-step-num">
                  {st.done ? <LhIcon name="check" size={15} sw={3} /> : st.n}
                </div>
                <div className="lh-step-txt">
                  <div className="lh-step-title">{st.t}</div>
                  <div className="lh-step-sub">{st.s}</div>
                </div>
                {i < steps.length - 1 && <div className="lh-step-line" />}
              </div>
            ))}
          </div>

          <div className="lh-trust">
            <span className="lh-trust-ico"><LhIcon name="lock" size={18} /></span>
            <p><b>Solo se registra una vez.</b> Tus datos se reutilizan en todos los anexos y se guardan localmente en este dispositivo.</p>
          </div>

        </div>
      </aside>

      {/* ── COLUMNA DE FORMULARIOS ── */}
      <div className="lh-form-col">

        {/* PASO 1 — Tipo */}
        <div className="lh-fcard" onMouseEnter={() => setActiveStep(1)}>
          <div className="lh-fcard-head">
            <div className="lh-fcard-badge">1</div>
            <div>
              <div className="lh-fcard-title">¿Cómo participas en las licitaciones?</div>
              <div className="lh-fcard-sub">Esto define qué datos necesitamos registrar.</div>
            </div>
          </div>
          <div className="lh-fcard-body">
            <div className="lh-type-grid">
              {[
                { k: 'juridica', icon: 'building', tt: 'Persona Jurídica', ts: 'Empresa registrada con RUC (20…)' },
                { k: 'natural',  icon: 'user',     tt: 'Persona Natural',   ts: 'Profesional o negocio con RUC (10…)' },
              ].map(({ k, icon, tt, ts }) => (
                <button
                  key={k}
                  className={`lh-type-card${tipo === k ? ' lh-type-card--sel' : ''}`}
                  onClick={() => { setTipo(k); setShowErr(false); setConfirmando(false); setActiveStep(1); }}
                >
                  <span className={`lh-type-ico${tipo === k ? ' lh-type-ico--sel' : ''}`}>
                    <LhIcon name={icon} size={26} />
                  </span>
                  <span>
                    <span style={{ display: 'block', fontSize: '1.02rem', fontWeight: 700, color: tipo === k ? '#0f766e' : '#16203a' }}>{tt}</span>
                    <span style={{ display: 'block', fontSize: '0.83rem', color: '#64748b', marginTop: 2 }}>{ts}</span>
                  </span>
                  <span className={`lh-type-check${tipo === k ? ' lh-type-check--sel' : ''}`}>
                    {tipo === k && <LhIcon name="check" size={13} sw={3} />}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* PASO 2 — Datos generales */}
        <div className="lh-fcard" ref={genRef} onMouseEnter={() => setActiveStep(2)}>
          <div className="lh-fcard-head">
            <div className="lh-fcard-badge">2</div>
            <div>
              <div className="lh-fcard-title">Datos generales</div>
              <div className="lh-fcard-sub">Información principal de {tipo === 'juridica' ? 'la empresa' : 'la persona'}.</div>
            </div>
            <div className="lh-req-legend">
              <span style={{ color: '#dc2626', fontWeight: 700 }}>*</span> Campos obligatorios
            </div>
          </div>
          <div className="lh-fcard-body">
            <div className="lh-field-grid">
              {schema.generales.map(f => (
                <LhField key={f.key} field={f} value={data[f.key] || ''} onChange={set(f.key)} showErr={showErr} />
              ))}
            </div>
          </div>
        </div>

        {/* PASO 3 — Representante legal (solo Jurídica) */}
        {schema.postor && (
          <div className="lh-fcard" ref={postorRef} onMouseEnter={() => setActiveStep(3)}>
            <div className="lh-fcard-head">
              <div className="lh-fcard-badge">3</div>
              <div>
                <div className="lh-fcard-title">Representante legal</div>
                <div className="lh-fcard-sub">Persona que firmará los documentos de oferta.</div>
              </div>
              <div className="lh-req-legend">
                <span style={{ color: '#dc2626', fontWeight: 700 }}>*</span> Campos obligatorios
              </div>
            </div>
            <div className="lh-fcard-body">
              <div className="lh-field-grid">
                {schema.postor.map(f => (
                  <LhField key={f.key} field={f} value={data[f.key] || ''} onChange={set(f.key)} showErr={showErr} />
                ))}
              </div>
            </div>
          </div>
        )}

        {/* PASO 4 — Datos registrales (solo Jurídica) */}
        {schema.registrales && (
          <div className="lh-fcard" ref={regRef} onMouseEnter={() => setActiveStep(tipo === 'juridica' ? 4 : 3)}>
            <div className="lh-fcard-head">
              <div className="lh-fcard-badge">{tipo === 'juridica' ? 4 : 3}</div>
              <div>
                <div className="lh-fcard-title">Datos registrales — SUNARP</div>
                <div className="lh-fcard-sub">Inscripción en Registros Públicos.</div>
              </div>
            </div>
            <div className="lh-fcard-body">
              <div className="lh-field-grid lh-field-grid--3">
                {schema.registrales.map(f => (
                  <LhField key={f.key} field={f} value={data[f.key] || ''} onChange={set(f.key)} showErr={showErr} />
                ))}
              </div>
            </div>
          </div>
        )}

        {/* MYPE */}
        <div className="lh-fcard">
          <div className="lh-fcard-head">
            <div className="lh-fcard-badge">🏷️</div>
            <div>
              <div className="lh-fcard-title">Condición MYPE</div>
              <div className="lh-fcard-sub">Micro o Pequeña Empresa según SUNAT</div>
            </div>
          </div>
          <div className="lh-fcard-body">
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {[['SI', 'Sí, somos MYPE', '#059669', '#f0fdf4', '#bbf7d0'], ['NO', 'No somos MYPE', '#dc2626', '#fef2f2', '#fecaca']].map(([val, lbl, color, bg, border]) => (
                <label key={val} style={{
                  display: 'flex', alignItems: 'center', gap: 9, cursor: 'pointer', userSelect: 'none',
                  background: data.es_mype === val ? bg : 'white',
                  border: `2px solid ${data.es_mype === val ? border : '#e5e7eb'}`,
                  borderRadius: 10, padding: '10px 22px', fontWeight: 600, fontSize: 14,
                  color: data.es_mype === val ? color : '#6b7280',
                  boxShadow: data.es_mype === val ? `0 2px 10px ${color}25` : 'none',
                  transition: 'all 0.15s',
                }}>
                  <input type="radio" name="lh_es_mype" value={val}
                    checked={data.es_mype === val}
                    onChange={() => setData(d => ({ ...d, es_mype: val }))}
                    style={{ accentColor: color }} />
                  {lbl}
                </label>
              ))}
            </div>
            <p style={{ margin: '10px 0 0', fontSize: 12, color: '#94a3b8' }}>
              Este dato se usará automáticamente en el Anexo 1 y, cuando el procedimiento contemple la bonificación MYPE, en el Anexo 16.
            </p>
          </div>
        </div>

        {/* BARRA DE GUARDAR */}
        <p className="lh-sync-note">{cargando
          ? 'Sincronizando con tu cuenta…'
          : enLaNube
            ? 'Tus datos quedan guardados en tu cuenta: al entrar desde otra PC aparecen aquí.'
            : 'Sin conexión con tu cuenta: se guardan en este equipo y se sincronizarán solos.'}</p>
        <div className="lh-savebar">
          {confirmando ? (
            <>
              <div className="lh-save-status lh-save-status--danger">
                <span className="lh-save-chip lh-save-chip--danger">
                  <LhIcon name="alert" size={15} sw={2} />
                </span>
                <span>Se borrarán los datos de {etiquetaTipo} en este equipo y en tu cuenta.</span>
              </div>
              <div className="lh-savebar-actions">
                <button type="button" className="lh-btn-ghost" onClick={() => setConfirmando(false)} disabled={limpiando}>
                  Cancelar
                </button>
                <button type="button" className="lh-btn-clear lh-btn-clear--firm" onClick={handleClear} disabled={limpiando}>
                  <LhIcon name="trash" size={17} /> {limpiando ? 'Borrando…' : 'Sí, borrar'}
                </button>
              </div>
            </>
          ) : (
            <>
              <div className={`lh-save-status${remaining > 0 ? ' lh-save-status--incomplete' : ' lh-save-status--ready'}`}>
                <span className={`lh-save-chip${remaining > 0 ? ' lh-save-chip--warn' : ' lh-save-chip--ok'}`}>
                  {remaining > 0
                    ? <LhIcon name="alert" size={15} sw={2} />
                    : <LhIcon name="check" size={15} sw={3} />
                  }
                </span>
                {remaining > 0
                  ? <span>Faltan {remaining} {remaining === 1 ? 'dato obligatorio' : 'datos obligatorios'}</span>
                  : <span>Listo para guardar</span>
                }
              </div>
              <div className="lh-savebar-actions">
                <button
                  type="button"
                  className="lh-btn-clear"
                  onClick={() => setConfirmando(true)}
                  disabled={cargando || saving || !hayDatos}
                  title={hayDatos ? `Borrar los datos de ${etiquetaTipo}` : 'No hay datos que borrar'}
                >
                  <LhIcon name="trash" size={17} /> Limpiar datos
                </button>
                <button type="button" className="lh-btn-save" onClick={handleSave} disabled={cargando || saving}>
                  <LhIcon name="save" size={18} /> {saving ? 'Guardando…' : 'Guardar datos'}
                </button>
              </div>
            </>
          )}
        </div>

      </div>

      {/* TOAST */}
      <div className={`lh-toast${toast ? ' lh-toast--show' : ''}`}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={vistaToast.tono === 'warn' ? '#fcd34d' : '#6ee7a8'} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        {vistaToast.texto}
      </div>

    </div></fieldset>
  );
};

/* ═══════════════════════════════════════════════════════════
   GENERAR OFERTA — wizard 3 pasos (diseño LicitaHub)
══════════════════════════════════════════════════════════ */

/* ── Campos simples para el wizard ── */
const GField = ({ label, name, value, onChange, placeholder, type = 'text', icon, required, colFull }) => (
  <div className={colFull ? 'go-col-full' : ''}>
    <label className="go-field-label-w">
      {label}{required && <span style={{ color:'#dc2626', marginLeft:3 }}>*</span>}
    </label>
    <div className="go-input-wrap">
      {icon && <span className="go-input-ico"><LhIcon name={icon} size={18} /></span>}
      <input type={type} name={name} value={value} onChange={onChange} placeholder={placeholder}
        className="go-field-input-w" style={{ paddingLeft: icon ? 44 : 14 }}
        onFocus={e => { e.target.style.borderColor='#0d9488'; e.target.style.boxShadow='0 0 0 4px rgba(13,148,136,0.12)'; }}
        onBlur={e =>  { e.target.style.borderColor='#dfe4ec'; e.target.style.boxShadow='none'; }}
      />
    </div>
  </div>
);
const GSelect = ({ label, name, value, onChange, options, icon, required, colFull }) => (
  <div className={colFull ? 'go-col-full' : ''}>
    <label className="go-field-label-w">
      {label}{required && <span style={{ color:'#dc2626', marginLeft:3 }}>*</span>}
    </label>
    <div className="go-input-wrap">
      {icon && <span className="go-input-ico"><LhIcon name={icon} size={18} /></span>}
      <select name={name} value={value} onChange={onChange}
        className="go-field-input-w go-field-select-w" style={{ paddingLeft: icon ? 44 : 14 }}>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  </div>
);

const GenerarOferta = ({ goToEmpresa, empresas }) => {
  const [tipoPersona, setTipoPersona] = useState('PJ');
  const empresaData = empresas[tipoPersona] || null;
  const [step, setStep]               = useState(0); // 0=proc, 1=anexos, 2=datos
  const [procedimiento, setProcedimiento] = useState('');
  const [objeto, setObjeto]           = useState('');
  // Modalidad de participación: individual o consorcio. Consorcio aún no está
  // habilitado (plantillas de promesa de consorcio en elaboración).
  const [modalidadParticipacion, setModalidadParticipacion] = useState('individual');
  // Las marcas de anexos se recuerdan por cada combinación procedimiento+objeto
  // y se persisten en localStorage, de modo que se restauran tal cual quedaron
  // aunque se cambie de procedimiento, de pestaña o se recargue la página.
  const [selMap, setSelMap]           = useState(() => {
    try { return JSON.parse(localStorage.getItem('nuvia_sel_anexos_v2') || '{}'); } catch { return {}; }
  });
  const ctxKey                        = `${procedimiento}__${objeto}`;
  const sel                           = selMap[ctxKey] || SEL_DEFAULT;
  const setSel = (updater) => setSelMap(prev => {
    const cur  = prev[ctxKey] || SEL_DEFAULT;
    const next = typeof updater === 'function' ? updater(cur) : updater;
    return { ...prev, [ctxKey]: next };
  });
  useEffect(() => {
    try { localStorage.setItem('nuvia_sel_anexos_v2', JSON.stringify(selMap)); } catch {}
  }, [selMap]);
  const [sistemaEntrega, setSistemaEntrega] = useState('No aplica');
  // Llave en mano: la entidad puede evaluar solo el plazo de entrega del bien, o el
  // plazo total considerando también la instalación y puesta en funcionamiento.
  // true  → Anexo 12 "llave en mano" (entrega + instalación)  → anexo12_llave_mano.docx
  // false → Anexo 12 estándar (solo entrega del bien)          → anexo12.docx
  const [evaluarInstalacion, setEvaluarInstalacion] = useState(true);
  const [modalidadPago, setModalidadPago]   = useState('Suma Alzada');
  const [formOferta, setFormOferta]   = useState(FORM_OFERTA_0);
  const [filasExp, setFilasExp]       = useState([{ ...FILA_EXP_0 }]);
  const [filasPers, setFilasPers]     = useState([{ ...FILA_PERS_0 }]);
  const [filasAnexo6, setFilasAnexo6] = useState([{ ...FILA_ANEXO6_0 }]);
  const [showErr, setShowErr]         = useState(false);
  const [generando, setGenerando]     = useState(false);
  const [errorMsg, setErrorMsg]       = useState('');
  const [successMsg, setSuccessMsg]   = useState('');
  const [modalAnexo, setModalAnexo]   = useState(null); // anexo cuyo modal de datos está abierto
  const anexo6Snapshot = useRef(null);
  const anexo6Trigger = useRef(null);
  const editorHeading = useRef(null);
  const abrirAnexo = (id, trigger) => {
    if (id === 'anexo6') {
      anexo6Trigger.current = trigger || document.activeElement;
      anexo6Snapshot.current = { filas: filasAnexo6.map(f => ({ ...f })), form: { ...formOferta } };
    }
    setModalAnexo(id);
  };
  const cerrarAnexo6 = (cancelar = false) => {
    if (cancelar && anexo6Snapshot.current) {
      setFilasAnexo6(anexo6Snapshot.current.filas);
      setFormOferta(anexo6Snapshot.current.form);
    }
    setModalAnexo(null);
  };
  const [anexosEnCarpeta, setAnexosEnCarpeta] = useState(null); // null = cargando

  const procInfoTmp = PROCEDIMIENTOS.find(p => p.id === procedimiento);
  const hasObjetosTmp = !!(procInfoTmp?.objetos?.length);

  useEffect(() => {
    if (!procedimiento || (hasObjetosTmp && !objeto)) { setAnexosEnCarpeta(null); return; }
    let cancelado = false;
    const folder = procInfoTmp.folder || procInfoTmp.id;
    setAnexosEnCarpeta(null);

    const llaveMano = esAnexo12LlaveMano(procedimiento, sistemaEntrega) && evaluarInstalacion;
    (async () => {
      const resultados = await Promise.all(ANEXOS.map(async (a) => {
        const path = getTemplatePath(folder, objeto, tipoPersona, a.id, a.id === 'anexo12' && llaveMano, modalidadPago);
        try {
          const res = await fetch(path, { method: 'HEAD' });
          const ct = res.headers.get('content-type') || '';
          // Si el archivo NO existe, el servidor devuelve una página HTML
          return (res.ok && !ct.includes('text/html')) ? a.id : null;
        } catch { return null; }
      }));
      if (!cancelado) setAnexosEnCarpeta(resultados.filter(Boolean));
    })();

    return () => { cancelado = true; };
  }, [procedimiento, objeto, tipoPersona, sistemaEntrega, evaluarInstalacion, modalidadPago]);

  // En Licitación Pública Abreviada hay opciones aún no habilitadas; si alguna quedó
  // seleccionada al cambiar de procedimiento, se vuelve al valor por defecto.
  useEffect(() => {
    if (procedimiento === 'licitacion_publica_abreviada') {
      setSistemaEntrega(s => LPA_SISTEMA_ENTREGA_OFF.includes(s) ? 'No aplica' : s);
      setModalidadPago(m => LPA_MODALIDAD_PAGO_OFF.includes(m) ? 'Suma Alzada' : m);
    }
  }, [procedimiento]);

  const procInfo       = PROCEDIMIENTOS.find(p => p.id === procedimiento);
  const hasObjetos     = !!(procInfo?.objetos?.length);
  const objetoInfo     = procInfo?.objetos?.find(o => o.id === objeto);
  const anexo12LlaveMano = esAnexo12LlaveMano(procedimiento, sistemaEntrega);
  // Solo se usa la plantilla "llave en mano" (con instalación) si el usuario decide
  // evaluar la instalación por separado; en caso contrario se usa el Anexo 12 estándar.
  const usarPlantillaLlaveMano = anexo12LlaveMano && evaluarInstalacion;
  const esLPA = procedimiento === 'licitacion_publica_abreviada';
  const esPreciosUnitarios = modalidadPago === 'Precios Unitarios';
  // En Concurso Público Abreviado de Consultoría en General (Suma Alzada y Precios
  // Unitarios) el Anexo 6 incluye el "Resumen del presupuesto ofertado": se piden los
  // % de Gastos Generales y Utilidad, y el Sub Total, IGV (18%) y Monto Ofertado se
  // calculan automáticamente.
  const esConsultoriaResumen = procedimiento === 'concurso_publico_abreviado' && objeto === 'Consultoria_General';
  const sistemaEntregaOff = (opt) => SISTEMA_ENTREGA_OFF.includes(opt) || (esLPA && LPA_SISTEMA_ENTREGA_OFF.includes(opt));
  const modalidadPagoOff  = (opt) => MODALIDAD_PAGO_OFF.includes(opt) || (esLPA && LPA_MODALIDAD_PAGO_OFF.includes(opt));

const isAnexoDisponible = (anexoId) => {
    if (!anexosEnCarpeta || !anexosEnCarpeta.includes(anexoId)) return false;
    // El Anexo 6 usa la plantilla propia de cada modalidad (Suma Alzada o
    // Precios Unitarios). anexosEnCarpeta ya refleja qué plantilla existe según
    // la modalidad; solo se descarta cuando no aplica (p. ej. Esquema Mixto).
    if (anexoId === 'anexo6'  && modalidadPago !== 'Suma Alzada' && modalidadPago !== 'Precios Unitarios') return false;
    if (anexoId === 'anexo12' && sistemaEntrega  !== 'No aplica' && !anexo12LlaveMano) return false;
    return true;
  };

  // Un anexo solo se muestra si su plantilla existe en la carpeta del procedimiento;
  // los que no se pueden seleccionar (sin plantilla) no se listan. Durante la carga
  // (anexosEnCarpeta === null) se muestran todos.
  const anexoVisible = (anexoId) => anexosEnCarpeta === null || anexosEnCarpeta.includes(anexoId);

  const anexosUI         = useMemo(() => getAnexosUI(procedimiento, objeto), [procedimiento, objeto]);
  const columnasPers     = getColumnasPers(procedimiento, objeto);
  const selectedAnexos   = anexosUI.filter(a => sel[a.id] && isAnexoDisponible(a.id));
  const selCount         = selectedAnexos.length;
  const selectedAnexoIds = selectedAnexos.map(a => a.id);
  const nombre           = tipoPersona === 'PJ' ? (empresaData?.razon_social || '') : (empresaData?.nombre_completo || '');
  const ready            = !!(empresaData && nombre);
  const step0Valid       = !!procedimiento && (!hasObjetos || !!objeto);
  const step1Valid       = selCount > 0;

  const handleSelectProcedimiento = (procId) => {
    const proc = PROCEDIMIENTOS.find(p => p.id === procId);
    if (proc?.disponible === false) return; // Words aún no elaborados
    setModalAnexo(null);
    setProcedimiento(procId);
    setObjeto('');
    // No se reinician las marcas: cada procedimiento+objeto conserva su propia
    // selección en selMap y se restaura al volver a él.
  };

  const handleSelectObjeto = (objId) => {
    const obj = procInfo?.objetos?.find(o => o.id === objId);
    if (obj?.disponible === false) return; // Words aún no elaborados
    setModalAnexo(null);
    setObjeto(objId);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormOferta(prev => {
      const next = { ...prev, [name]: value };
      if (name === 'precio') {
        const n = parseFloat(value.replace(/,/g, ''));
        next.oferta_letras = isNaN(n) ? '' : numeroALetras(n);
      }
      return next;
    });
  };

  const addFilaExp    = () => setFilasExp(prev => [...prev, { ...FILA_EXP_0 }]);
  const removeFilaExp = (i) => setFilasExp(prev => prev.length > 1 ? prev.filter((_, idx) => idx !== i) : prev);
  const updateFilaExp = (i, key, value) => setFilasExp(prev => prev.map((f, idx) => idx === i ? { ...f, [key]: value } : f));

  const addFilaPers    = () => setFilasPers(prev => [...prev, { ...FILA_PERS_0 }]);
  const removeFilaPers = (i) => setFilasPers(prev => prev.length > 1 ? prev.filter((_, idx) => idx !== i) : prev);
  const updateFilaPers = (i, key, value) => setFilasPers(prev => prev.map((f, idx) => idx === i ? { ...f, [key]: value } : f));

  // Anexo 6: ítems de la oferta económica. El monto en letras se recalcula del total.
  // Precio (numérico) de cada ítem según la modalidad: en Precios Unitarios es
  // cantidad × precio unitario; en Suma Alzada es el precio del ítem.
  const precioFilaAnexo6 = (f) => {
    if (esPreciosUnitarios) {
      const cant = parseFloat(String(f.cantidad).replace(/,/g, '')) || 0;
      const pu   = parseFloat(String(f.precio_unitario).replace(/,/g, '')) || 0;
      return cant * pu;
    }
    return parseFloat(String(f.precio).replace(/,/g, '')) || 0;
  };
  const totalAnexo6 = (filas) => filas.reduce((s, f) => s + precioFilaAnexo6(f), 0);
  // Resumen del presupuesto (solo Consultoría en General). Todo a 2 decimales.
  //  · Precios Unitarios (hacia adelante): la suma de los ítems es el Costo Directo;
  //    GG y U son % del CD, ST = CD+GG+U, IGV = 18%·ST, Monto Ofertado = ST+IGV.
  //  · Suma Alzada (hacia atrás): la suma de los ítems ES el Monto Ofertado (IGV
  //    incluido); ST = Monto/1.18, IGV = Monto−ST, y el ST se desglosa en
  //    CD = ST/(1+GG%+U%), GG = CD·GG%, U = ST−CD−GG.
  const computeResumen = (filas, ggPct, uPct) => {
    const suma = round2(totalAnexo6(filas));
    const g = (parseFloat(ggPct) || 0) / 100;
    const uu = (parseFloat(uPct) || 0) / 100;
    if (esPreciosUnitarios) {
      const cd  = suma;
      const gg  = round2(cd * g);
      const u   = round2(cd * uu);
      const st  = round2(cd + gg + u);
      const igv = round2(st * 0.18);
      const monto = round2(st + igv);
      return { cd, gg, u, st, igv, monto };
    }
    const monto = suma;
    const st  = round2(monto / 1.18);
    const igv = round2(monto - st);
    const cd  = round2(st / (1 + g + uu));
    const gg  = round2(cd * g);
    const u   = round2(st - cd - gg); // U absorbe el redondeo para que CD+GG+U = ST
    return { cd, gg, u, st, igv, monto };
  };
  const recomputeLetrasAnexo6 = (filas) => {
    setFormOferta(fp => {
      // El monto en letras corresponde al Monto Ofertado (ST+IGV) cuando aplica el
      // resumen; en el resto de casos, a la suma directa de los ítems.
      const total = esConsultoriaResumen
        ? computeResumen(filas, fp.gastos_generales_pct, fp.utilidad_pct).monto
        : totalAnexo6(filas);
      return { ...fp, oferta_letras: total > 0 ? numeroALetras(total) : '' };
    });
  };
  // Cambia el % de GG o U y recalcula el monto en letras (Monto Ofertado).
  const updatePctResumen = (name, value) => setFormOferta(fp => {
    const next = { ...fp, [name]: value };
    const monto = computeResumen(
      filasAnexo6,
      name === 'gastos_generales_pct' ? value : fp.gastos_generales_pct,
      name === 'utilidad_pct'         ? value : fp.utilidad_pct,
    ).monto;
    next.oferta_letras = monto > 0 ? numeroALetras(monto) : '';
    return next;
  });
  const addFilaAnexo6    = () => setFilasAnexo6(prev => [...prev, { ...FILA_ANEXO6_0 }]);
  const removeFilaAnexo6 = (i) => {
    if (filasAnexo6.length <= 1) return;
    const next = filasAnexo6.filter((_, idx) => idx !== i);
    setFilasAnexo6(next);
    recomputeLetrasAnexo6(next);
  };
  const updateFilaAnexo6 = (i, key, value) => {
    const next = filasAnexo6.map((f, idx) => idx === i ? { ...f, [key]: value } : f);
    setFilasAnexo6(next);
    if (key === 'precio' || key === 'cantidad' || key === 'precio_unitario') recomputeLetrasAnexo6(next);
  };

  /* Anexos que requieren completar datos propios: al marcarlos se abre el
     modal correspondiente. Los demás se completan automáticamente. El anexo
     del personal clave depende del procedimiento (Anexo 19, o Anexo 16 en
     Consultoría en General). */
  const anexoPersClaveId = getAnexoPersonalClave(procedimiento, objeto);
  const ANEXOS_CON_DATOS = ['anexo6', 'anexo11', 'anexo12', anexoPersClaveId];

  const toggleAnexo = (anexoId) => {
    if (!isAnexoDisponible(anexoId)) return;
    const activando = !sel[anexoId];
    setSel(prev => ({ ...prev, [anexoId]: !prev[anexoId] }));
    if (activando && ANEXOS_CON_DATOS.includes(anexoId)) abrirAnexo(anexoId);
  };

  const datosAnexoCompletos = (anexoId) => {
    if (anexoId === 'anexo6') {
      const tocada  = (f) => esPreciosUnitarios
        ? (f.concepto.trim() || String(f.cantidad).trim() || String(f.precio_unitario).trim())
        : (f.concepto.trim() || String(f.precio).trim());
      const completa = (f) => esPreciosUnitarios
        ? (f.concepto.trim() && String(f.cantidad).trim() && String(f.precio_unitario).trim())
        : (f.concepto.trim() && String(f.precio).trim());
      const conDatos = filasAnexo6.filter(tocada);
      return conDatos.length > 0 && conDatos.every(completa) && !!formOferta.oferta_letras.trim();
    }
    if (anexoId === 'anexo12') return !!String(formOferta.plazo).trim() && (!usarPlantillaLlaveMano || !!String(formOferta.plazo_instalacion).trim());
    if (anexoId === 'anexo11') return filasExp.some(f => f.cliente.trim());
    if (anexoId === anexoPersClaveId) return filasPers.some(f => f.nombres.trim());
    return true;
  };

  // Nota: las marcas nunca se borran automáticamente. Si un anexo marcado no
  // está disponible en el contexto actual (sin plantilla, otra modalidad, etc.)
  // simplemente se excluye al leer (isAnexoDisponible) sin perder la marca.

  const generar = async () => {
    setErrorMsg(''); setSuccessMsg('');
    if (!empresaData) return setErrorMsg('Sin datos de empresa. Ve a "Mi Empresa" primero.');
    if (!procedimiento) return setErrorMsg('Selecciona el tipo de procedimiento.');
    if (hasObjetos && !objeto) return setErrorMsg('Selecciona el objeto de contratación (Bienes, Obra, etc.).');
    if (!selectedAnexos.length) return setErrorMsg('Selecciona al menos un anexo.');
    if (!formOferta.nomenclatura.trim()) return setErrorMsg('La nomenclatura es obligatoria.');
    if (!formOferta.fecha_envio) return setErrorMsg('La fecha de envío es obligatoria.');
    if (selectedAnexoIds.includes('anexo6')) {
      if (esPreciosUnitarios) {
        const tocada   = (f) => f.concepto.trim() || String(f.cantidad).trim() || String(f.precio_unitario).trim();
        const completa = (f) => f.concepto.trim() && String(f.cantidad).trim() && String(f.precio_unitario).trim();
        if (!filasAnexo6.some(completa)) return setErrorMsg('Agrega al menos un ítem con concepto, cantidad y precio unitario en el Anexo 6.');
        if (filasAnexo6.some(f => tocada(f) && !completa(f))) return setErrorMsg('Cada ítem del Anexo 6 debe tener concepto, cantidad y precio unitario.');
      } else {
        if (!filasAnexo6.some(f => f.concepto.trim() && String(f.precio).trim())) return setErrorMsg('Agrega al menos un ítem con concepto y precio en el Anexo 6.');
        if (filasAnexo6.some(f => (f.concepto.trim() && !String(f.precio).trim()) || (!f.concepto.trim() && String(f.precio).trim()))) return setErrorMsg('Cada ítem del Anexo 6 debe tener concepto y precio.');
      }
      if (!formOferta.oferta_letras.trim()) return setErrorMsg('El monto en letras es obligatorio para el Anexo 6.');
    }
    if (selectedAnexoIds.includes('anexo12') && !String(formOferta.plazo).trim()) return setErrorMsg('El plazo de entrega es obligatorio para el Anexo 12.');
    if (selectedAnexoIds.includes('anexo12') && usarPlantillaLlaveMano && !String(formOferta.plazo_instalacion).trim()) return setErrorMsg('El plazo de instalación es obligatorio para el Anexo 12 (Llave en mano con instalación).');
    if (selectedAnexoIds.includes('anexo11') && !filasExp.some(f => f.cliente.trim())) return setErrorMsg('Agrega al menos una fila con cliente en el Anexo 11.');
    if (selectedAnexoIds.includes(anexoPersClaveId) && !filasPers.some(f => f.nombres.trim())) return setErrorMsg('Agrega al menos una fila con nombres del personal clave.');

    setGenerando(true);

    const { dias, mes, anio } = splitFecha(formOferta.fecha_envio);
    const commonFechaVars = {
      fecha_envio: formatFecha(formOferta.fecha_envio),
      cotizacion_dias: dias, cotizacion_mes: mes, cotizacion_anio: anio,
      cotizacioin_dias: dias, // alias por error de tipeo en la plantilla del Anexo 2
    };
    const simboloMoneda = (m) => m === 'Dólares' ? 'US$' : 'S/';
    const formatPrecio = (v) => {
      const n = parseFloat(String(v).replace(/,/g, ''));
      return isNaN(n) ? '' : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    const sim = simboloMoneda(formOferta.tipo_moneda);
    // Precio total (numérico) de cada ítem: en Precios Unitarios = cantidad ×
    // precio unitario; en Suma Alzada = el precio del ítem.
    const precioTotalFila = (f) => esPreciosUnitarios
      ? (parseFloat(String(f.cantidad).replace(/,/g, '')) || 0) * (parseFloat(String(f.precio_unitario).replace(/,/g, '')) || 0)
      : (parseFloat(String(f.precio).replace(/,/g, '')) || 0);
    const filaTocada = (f) => esPreciosUnitarios
      ? (f.concepto.trim() || String(f.cantidad).trim() || String(f.precio_unitario).trim())
      : (f.concepto.trim() || String(f.precio).trim());
    const itemsAnexo6 = filasAnexo6.filter(filaTocada);
    const totalAnexo6Num = itemsAnexo6.reduce((s, f) => s + precioTotalFila(f), 0);
    // Resumen del presupuesto (Consultoría en General). El cálculo depende de la
    // modalidad (ver computeResumen): en Suma Alzada el Monto Ofertado = suma de los
    // ítems (IGV incluido); en Precios Unitarios el IGV se agrega sobre el Costo Directo.
    const ggPctNum = parseFloat(formOferta.gastos_generales_pct) || 0;
    const uPctNum  = parseFloat(formOferta.utilidad_pct) || 0;
    const { cd: cdMonto, gg: ggMonto, u: uMonto, st: stMonto, igv: igvMonto, monto: montoOfertado } =
      computeResumen(itemsAnexo6, ggPctNum, uPctNum);
    const fmtPct = (v) => (parseFloat(v) || 0).toLocaleString('en-US', { maximumFractionDigits: 2 });
    const ofertaVars = {
      // Ítems de la oferta económica del Anexo 6 (uno o varios). En Precios
      // Unitarios cada ítem expone además cantidad, precio_unitario y precio_total.
      items: itemsAnexo6.map((f, i) => {
        const precioTotalFmt = `${sim} ${formatPrecio(precioTotalFila(f))}`;
        return esPreciosUnitarios
          ? {
              nro: i + 1, // N° de ítem correlativo para tablas con columna "N°"
              concepto: f.concepto,
              unidad: (f.unidad || '').trim(), // unidad de medida (opcional)
              cantidad: String(f.cantidad).trim(),
              precio_unitario: `${sim} ${formatPrecio(f.precio_unitario)}`,
              precio_total: precioTotalFmt,
              precio: precioTotalFmt, // alias del precio total del ítem
            }
          : { concepto: f.concepto, precio: precioTotalFmt };
      }),
      total_oferta: `${sim} ${formatPrecio(totalAnexo6Num)}`,
      // Resumen del presupuesto (plantilla de Consultoría en General). Las claves
      // coinciden exactamente con los placeholders del Word (sensible a mayúsculas).
      COSTOS_DIRECTOS: `${sim} ${formatPrecio(cdMonto)}`,
      GASTOS_GENERALES: `${sim} ${formatPrecio(ggMonto)}`,
      UTILIDAD: `${sim} ${formatPrecio(uMonto)}`,
      SUB_TOTAL: `${sim} ${formatPrecio(stMonto)}`,
      impuesto_IGV: `${sim} ${formatPrecio(igvMonto)}`,
      monto_ofertado: `${sim} ${formatPrecio(montoOfertado)}`,
      gg_pct: fmtPct(ggPctNum),
      u_pct: fmtPct(uPctNum),
      // Compatibilidad: primer ítem expuesto como concepto/precio sueltos
      concepto: itemsAnexo6[0]?.concepto || '',
      precio: itemsAnexo6[0] ? `${sim} ${formatPrecio(precioTotalFila(itemsAnexo6[0]))}` : '',
      oferta_letras: formOferta.oferta_letras, tipo_moneda: formOferta.tipo_moneda,
      plazo_entrega: formOferta.plazo,
      plazo_instalacion: formOferta.plazo_instalacion,
      'plazo_instalación': formOferta.plazo_instalacion, // alias con tilde según la plantilla
      total_dias: String((parseInt(formOferta.plazo, 10) || 0) + (parseInt(formOferta.plazo_instalacion, 10) || 0)),
    };
    const experienciaVars = {
      filas: filasExp.map((f, i) => ({
        nro: i + 1, ...f,
        importe: f.importe ? `${simboloMoneda(f.moneda)} ${formatPrecio(f.importe)}` : '',
        monto_acumulado: f.monto_acumulado ? `${simboloMoneda(f.moneda)} ${formatPrecio(f.monto_acumulado)}` : '',
      })),
      total: `${simboloMoneda(filasExp[0]?.moneda)} ${formatPrecio(filasExp.reduce((s, f) => s + (parseFloat(String(f.monto_acumulado).replace(/,/g, '')) || 0), 0))}`,
      personal: filasPers.map((f, i) => ({ nro: i + 1, ...f })),
    };
    const vars = tipoPersona === 'PJ' ? {
      ...commonFechaVars, ...ofertaVars, ...experienciaVars,
      nomenclatura: formOferta.nomenclatura, nombre: empresaData.nombre || '',
      razon_social: empresaData.razon_social || '', tipo_documento: empresaData.tipo_documento || 'DNI',
      numero_documento: empresaData.numero_documento || '', sede_registral: empresaData.sede_registral || '',
      numero_partida_registral: empresaData.numero_partida_registral || '', numero_asiento: empresaData.numero_asiento || '',
      domicilio_legal: empresaData.domicilio_legal || '', ruc: empresaData.ruc || '',
      telefono: empresaData.telefono || '', marca_si: (empresaData?.es_mype || 'NO') === 'SI' ? 'X' : ' ',
      marca_no: (empresaData?.es_mype || 'NO') === 'NO' ? 'X' : ' ', correo_notificacion: empresaData.correo_notificacion || '',
      ciudad: empresaData.ciudad || '',
    } : {
      ...commonFechaVars, ...ofertaVars, ...experienciaVars,
      nomenclatura: formOferta.nomenclatura, nombre: empresaData.nombre_completo || '',
      razon_social: empresaData.nombre_completo || '', tipo_documento: empresaData.tipo_documento || '',
      numero_documento: empresaData.numero_documento || '', sede_registral: '', numero_partida_registral: '', numero_asiento: '',
      domicilio_legal: empresaData.domicilio || '', ruc: empresaData.ruc || '', telefono: empresaData.telefono || '',
      marca_si: (empresaData?.es_mype || 'NO') === 'SI' ? 'X' : ' ', marca_no: (empresaData?.es_mype || 'NO') === 'NO' ? 'X' : ' ',
      correo_notificacion: empresaData.correo || '', ciudad: empresaData.ciudad || '',
    };

    const base64Docs = [];
    // Renderiza una plantilla (arrayBuffer) con un set de variables y la añade a base64Docs.
    const renderDoc = (buf, renderVars) => {
      const zip = new PizZip(buf);
      const doc = new Docxtemplater(zip, { paragraphLoop: true, linebreaks: true, nullGetter: () => '' });
      doc.render(renderVars);
      const uint8 = doc.getZip().generate({ type: 'uint8array' });
      let binary = '';
      for (let i = 0; i < uint8.length; i++) binary += String.fromCharCode(uint8[i]);
      base64Docs.push(btoa(binary));
    };
    for (const { id: anexoId } of selectedAnexos) {
      const path = getTemplatePath(procInfo.folder || procInfo.id, objeto, tipoPersona, anexoId, anexoId === 'anexo12' && usarPlantillaLlaveMano, modalidadPago);
      try {
        const res = await fetch(path);
        if (!res.ok) { setErrorMsg(`Plantilla "${procInfo.label} — ${anexoId.toUpperCase()}" no disponible aún.`); setGenerando(false); return; }
        const contentType = res.headers.get('content-type') || '';
        if (contentType.includes('text/html')) { setErrorMsg(`Plantilla "${anexoId}" no encontrada (¿archivo subido a public/templates?).`); setGenerando(false); return; }
        const buf = await res.arrayBuffer();
        if (anexoId === 'anexo6' && !esPreciosUnitarios && !esConsultoriaResumen && itemsAnexo6.length > 1) {
          // Suma Alzada con varios ítems: en lugar de una sola tabla con varias
          // filas, se genera un Anexo 6 independiente por cada ítem (ítem 1, 2, 3…).
          // (En Precios Unitarios y en Consultoría en General —con resumen del
          // presupuesto— todos los ítems van en una sola tabla.)
          for (const it of itemsAnexo6) {
            const precioNum = parseFloat(String(it.precio).replace(/,/g, '')) || 0;
            const precioFmt = `${sim} ${formatPrecio(it.precio)}`;
            renderDoc(buf.slice(0), {
              ...vars,
              items: [{ concepto: it.concepto, precio: precioFmt }],
              total_oferta: precioFmt,
              concepto: it.concepto,
              precio: precioFmt,
              oferta_letras: precioNum > 0 ? numeroALetras(precioNum) : '',
            });
          }
        } else {
          renderDoc(buf, vars);
        }
      } catch (err) { setErrorMsg(`Error generando ${anexoId}: ${err.message}`); setGenerando(false); return; }
    }
// POR esto:
try {
  // Si hay un solo anexo, descargarlo directamente sin merger
  if (base64Docs.length === 1) {
    const binary = atob(base64Docs[0]);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    const razon = tipoPersona === 'PJ' ? empresaData.razon_social : empresaData.nombre_completo;
    const nombre = `OFERTA_${(razon||'').replace(/\s+/g,'_')}_${formOferta.nomenclatura}.docx`;
    const a = Object.assign(document.createElement('a'), { href: URL.createObjectURL(blob), download: nombre });
    document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(a.href);
    setGenerando(false);
    setSuccessMsg(`✓ Documento generado exitosamente.`);
    setTimeout(() => setSuccessMsg(''), 5000);
    return;
  }

  // Múltiples anexos: incrustarlos como altChunks para preservar notas al pie y numeración
  const uint8Docs = base64Docs.map(b64 => {
    const binary = atob(b64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes;
  });

  const merged = mergeDocxAltChunks(uint8Docs);
  const blob = new Blob([merged], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
  const razon = tipoPersona === 'PJ' ? empresaData.razon_social : empresaData.nombre_completo;
  const nombre = `OFERTA_${(razon||'').replace(/\s+/g,'_')}_${formOferta.nomenclatura}.docx`;
  const a = Object.assign(document.createElement('a'), { href: URL.createObjectURL(blob), download: nombre });
  document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(a.href);
  setGenerando(false);
  setSuccessMsg(`✓ ${base64Docs.length} anexos combinados en un solo documento.`);
  setTimeout(() => setSuccessMsg(''), 5000);
} catch (err) { setErrorMsg(`Error al combinar documentos: ${err.message}`); setGenerando(false); }};

  // ── Progreso y estado para el sidebar / barra de acción ──
  const anexoShort = (a) => (a?.label || '').split('—')[0].trim();
  const anexosIncompletos = selectedAnexos.filter(a => ANEXOS_CON_DATOS.includes(a.id) && !datosAnexoCompletos(a.id));
  const faltaNomenclatura = !formOferta.nomenclatura.trim();
  const listoParaGenerar = ready && step0Valid && anexosEnCarpeta !== null && selCount > 0 && anexosIncompletos.length === 0 && !faltaNomenclatura && !!formOferta.fecha_envio;
  const progresoSteps = [
    { key: 'proc', title: 'Procedimiento', state: step0Valid ? 'done' : 'todo',
      sub: procInfo ? `${procInfo.label}${objetoInfo ? ' · ' + objetoInfo.label : ''}` : 'Sin seleccionar' },
    { key: 'mod', title: 'Datos del proceso', state: !faltaNomenclatura && formOferta.fecha_envio ? 'done' : 'todo',
      sub: faltaNomenclatura ? 'Ingresa la nomenclatura y la fecha' : `${formOferta.nomenclatura} · ${modalidadPago}` },
    { key: 'anexos', title: 'Anexos y datos',
      state: selCount === 0 ? 'todo' : anexosIncompletos.length > 0 ? 'warn' : 'done',
      sub: selCount === 0 ? 'Sin anexos marcados'
        : anexosIncompletos.length > 0 ? `Falta 1 dato de ${anexoShort(anexosIncompletos[0])}`
        : `${selCount} anexo${selCount > 1 ? 's' : ''} listo${selCount > 1 ? 's' : ''}` },
  ];
  const statusMsg = !ready ? 'Registra los datos del postor en Mi Empresa'
    : !step0Valid ? 'Selecciona el procedimiento y objeto'
    : !formOferta.fecha_envio ? 'Falta la fecha de envío'
    : selCount === 0 ? 'Marca al menos un anexo'
    : anexosIncompletos.length > 0 ? `Falta completar datos de ${anexoShort(anexosIncompletos[0])}`
    : faltaNomenclatura ? 'Falta la nomenclatura del proceso'
    : 'Todo listo para generar tu oferta';

  // Contenido del formulario de datos del anexo (panel en línea, sin modal)
  const renderDatosAnexoBody = () => (
    <>

                {/* Anexo 12 — Plazo de entrega */}
                {modalAnexo === 'anexo12' && (
                  <>
                    {anexo12LlaveMano && (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <p style={{ margin: 0, fontSize: 12, color: '#475569', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 9, padding: '10px 14px', lineHeight: 1.5 }}>
                          <strong>Sistema de entrega llave en mano:</strong> la entidad contratante puede evaluar el plazo correspondiente a la entrega del bien, o el plazo total de ejecución considerando también la instalación y puesta en funcionamiento de los bienes. ¿Cómo se evaluará según las bases?
                        </p>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                          {[
                            { val: false, label: 'Solo entrega del bien',   hint: 'Anexo 12 estándar' },
                            { val: true,  label: 'Entrega + instalación',    hint: 'Anexo 12 llave en mano' },
                          ].map(opt => {
                            const isSel = evaluarInstalacion === opt.val;
                            return (
                              <button key={String(opt.val)} type="button" onClick={() => setEvaluarInstalacion(opt.val)} style={{
                                flex: '1 1 200px', textAlign: 'left', padding: '8px 12px', borderRadius: 9, border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                                background: isSel ? '#e7faf6' : '#f8fafc',
                                outline: isSel ? '2px solid #0d9488' : '1.5px solid #e5e7eb',
                                boxShadow: isSel ? '0 2px 8px rgba(13,148,136,0.12)' : 'none',
                              }}>
                                <span style={{ display: 'block', fontSize: 13, fontWeight: 700, color: isSel ? '#0f766e' : '#374151' }}>{isSel && '✓ '}{opt.label}</span>
                                <span style={{ display: 'block', fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{opt.hint}</span>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    <InputField label={usarPlantillaLlaveMano ? 'Plazo de entrega de bienes (días)' : 'Plazo de entrega (días)'} name="plazo" value={formOferta.plazo} onChange={handleChange} type="number" placeholder="Ej: 30" required />
                    {usarPlantillaLlaveMano && (
                      <InputField label="Plazo de instalación y puesta en funcionamiento (días)" name="plazo_instalacion" value={formOferta.plazo_instalacion} onChange={handleChange} type="number" placeholder="Ej: 15" required />
                    )}
                    <div style={{ fontSize: 13, color: '#374151', background: '#eff6ff', borderRadius: 9, padding: '12px 16px', border: '1px solid #bfdbfe' }}>
                      {usarPlantillaLlaveMano ? (
                        <>Modalidad <strong>Llave en mano</strong>: se sumará la entrega de bienes y la instalación para un total de <strong>{(parseInt(formOferta.plazo, 10) || 0) + (parseInt(formOferta.plazo_instalacion, 10) || 0)} días calendario</strong>.<br /><br /><em>En el caso del sistema de entrega llave en mano, la entidad contratante puede evaluar el plazo correspondiente a la entrega del bien o puede evaluar el plazo total de ejecución considerando también la instalación.</em></>
                      ) : (
                        <>Se completará con los datos de <strong>{empresaData?.razon_social || empresaData?.nombre_completo || '—'}</strong>, la fecha ingresada y el plazo de entrega indicado. Corresponde al factor de evaluación de plazo de entrega.</>
                      )}
                    </div>
                  </>
                )}

                {/* Anexo 11 — Experiencia del postor */}
                {modalAnexo === 'anexo11' && (
                  <>
                    {filasExp.map((fila, i) => (
                      <div key={i} style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 14, position: 'relative', background: '#fafafa' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: '#0e7490' }}>Contrato N° {i + 1}</span>
                          {filasExp.length > 1 && (
                            <button type="button" onClick={() => removeFilaExp(i)} style={{ border: 'none', background: '#fef2f2', color: '#dc2626', borderRadius: 7, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>✕ Quitar</button>
                          )}
                        </div>
                        <div className="go-grid">
                          {COLUMNAS_EXP.map(col => (
                            col.key === 'moneda' ? (
                              <SelectInput key={col.key} label={col.label} name={col.key} value={fila[col.key]} onChange={e => updateFilaExp(i, col.key, e.target.value)} options={['Soles', 'Dólares']} />
                            ) : (
                              <InputField key={col.key} label={col.label} name={col.key} value={fila[col.key]} onChange={e => updateFilaExp(i, col.key, e.target.value)} placeholder="" />
                            )
                          ))}
                        </div>
                      </div>
                    ))}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                      <button type="button" onClick={addFilaExp} style={{ border: '1px dashed #06b6d4', background: '#ecfeff', color: '#0e7490', borderRadius: 9, padding: '9px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>＋ Agregar fila</button>
                      <div style={{ fontSize: 13, color: '#374151' }}>
                        Monto facturado total: <strong>{filasExp[0]?.moneda === 'Dólares' ? 'US$' : 'S/'} {filasExp.reduce((s, f) => s + (parseFloat(String(f.monto_acumulado).replace(/,/g, '')) || 0), 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                      </div>
                    </div>
                  </>
                )}

                {/* Personal clave (Anexo 19, o Anexo 16 en Consultoría en General) */}
                {modalAnexo === anexoPersClaveId && (
                  <>
                    {filasPers.map((fila, i) => (
                      <div key={i} style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 14, position: 'relative', background: '#fafafa' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: '#6d28d9' }}>Profesional N° {i + 1}</span>
                          {filasPers.length > 1 && (
                            <button type="button" onClick={() => removeFilaPers(i)} style={{ border: 'none', background: '#fef2f2', color: '#dc2626', borderRadius: 7, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>✕ Quitar</button>
                          )}
                        </div>
                        <div className="go-grid">
                          {columnasPers.map(col => (
                            <InputField key={col.key} label={col.label} name={col.key} value={fila[col.key]} onChange={e => updateFilaPers(i, col.key, e.target.value)} placeholder="" />
                          ))}
                        </div>
                      </div>
                    ))}
                    <button type="button" onClick={addFilaPers} style={{ alignSelf: 'flex-start', border: '1px dashed #8b5cf6', background: '#f5f3ff', color: '#6d28d9', borderRadius: 9, padding: '9px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>＋ Agregar profesional</button>
                  </>
                )}


                  </>
  );

  return (
    <>
      <Modal zIndex={12000} isOpen={modalAnexo === 'anexo6'} toggle={() => cerrarAnexo6()} centered scrollable backdrop="static" keyboard trapFocus returnFocusAfterClose={false} labelledBy="go19-anexo6-title" className="go19-modal" contentClassName="go19-page go19-modal-content" onOpened={() => editorHeading.current?.focus()} onClosed={() => anexo6Trigger.current?.focus()}>
        <section className="go19-detail">
        <div className="go19-breadcrumb"><span>Generar Oferta · Anexos · <strong>Anexo 6 — Oferta Económica</strong></span><span className="go-chip-teal">{modalidadPago} · {objetoInfo?.label}</span></div>
        <div className="go19-editor-card">
          <header className="go19-editor-head"><span className="go19-check">✓</span><div><h2 id="go19-anexo6-title" tabIndex={-1} ref={editorHeading}>Anexo 6 — Oferta Económica</h2><p>{esPreciosUnitarios ? 'Indica la cantidad y el precio unitario de cada ítem' : 'La suma de los ítems es el Monto Ofertado (IGV incluido)'}</p></div><button type="button" className="go19-secondary" onClick={() => cerrarAnexo6()}>Cerrar ×</button></header>
          <OfertaEconomica19 filas={filasAnexo6} form={formOferta} unitarios={esPreciosUnitarios} consultoria={esConsultoriaResumen} resumen={computeResumen(filasAnexo6, formOferta.gastos_generales_pct, formOferta.utilidad_pct)} onChange={handleChange} onItemChange={updateFilaAnexo6} onAdd={addFilaAnexo6} onRemove={removeFilaAnexo6} onPct={updatePctResumen} onLetras={() => recomputeLetrasAnexo6(filasAnexo6)} precioFila={precioFilaAnexo6} />
          <footer className="go19-editor-foot"><span role="status" className={datosAnexoCompletos('anexo6') ? 'go19-ok' : 'go19-warn'}>{datosAnexoCompletos('anexo6') ? '✓ Datos completos — el Anexo 6 ya se puede generar' : 'Completa los conceptos, precios y el monto en letras'}</span><div><button type="button" className="go19-secondary" onClick={() => cerrarAnexo6(true)}>Cancelar</button><button type="button" className="go19-primary" disabled={!datosAnexoCompletos('anexo6')} onClick={() => cerrarAnexo6()}>✓ Guardar y continuar</button></div></footer>
        </div>
        </section>
      </Modal>
    <div className="go-layout">

      {/* ── SIDEBAR ── */}
      <aside>
        <div className="go-aside-sticky">

          <section className="go19-sidecard">
            <h2 className="go19-sidehead">POSTOR</h2>
            <div className="go19-sidebody">
              <div className="go19-personas">{[['PJ', 'Persona Jurídica'], ['PN', 'Persona Natural']].map(([v, label]) => <button type="button" key={v} aria-pressed={tipoPersona === v} onClick={() => setTipoPersona(v)}>{label}</button>)}</div>
              <div className={ready ? 'go19-company' : 'go19-company go19-company--pending'}><LhIcon name={ready ? 'check' : 'info'} size={16} /><div><strong>{nombre || 'Sin datos del postor'}</strong><span>{ready ? 'RUC ' + (empresaData.ruc || 'sin registrar') : 'Registra tus datos para generar la oferta'}</span></div></div>
              <button type="button" className="go19-edit" onClick={goToEmpresa}><LhIcon name="edit2" size={13} />{ready ? 'Editar datos de la empresa' : 'Registrar datos del postor'}</button>
            </div>
          </section>
          <section className="go19-sidecard go19-sidebody"><h2 className="go-sum-label">PROGRESO</h2><div className="go-progress">{progresoSteps.map(s => <div key={s.key} className={'go-prog-step ' + s.state}><span className="go-prog-dot">{s.state === 'done' ? '✓' : s.state === 'warn' ? '•' : ''}</span><div><div className="go-prog-title">{s.title}</div><div className="go-prog-sub">{s.sub}</div></div></div>)}</div></section>
          <section className="go19-sidecard"><h2 className="go19-sidehead go19-sidehead--plain">ANEXOS INCLUIDOS <span>{selCount}</span></h2><div className="go19-sidebody go19-included">{selCount === 0 ? <p>Marca los anexos que incluirás en tu oferta.</p> : selectedAnexos.map(a => <div key={a.id}><span className={datosAnexoCompletos(a.id) ? 'go19-ok' : 'go19-warn'}>{datosAnexoCompletos(a.id) ? '⊙' : '!'}</span><span>{a.label}</span>{!datosAnexoCompletos(a.id) && <small>datos</small>}</div>)}</div></section>

          {/* Trust */}
          <div className="go-trust-note">
            <span style={{ color: '#0d9488', flexShrink: 0, marginTop: 1 }}><LhIcon name="lock" size={15} /></span>
            <p style={{ margin: 0, fontSize: '0.77rem', color: '#64748b', lineHeight: 1.5 }}>
              Tus datos se guardan localmente y se reutilizan en todos los anexos.
            </p>
          </div>

          {/* Mensajes */}
          {errorMsg && (
            <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 9, padding: '10px 12px', color: '#dc2626', fontSize: 12, display: 'flex', alignItems: 'flex-start', gap: 7 }}>
              <span style={{ flexShrink: 0 }}>⚠️</span>{errorMsg}
            </div>
          )}
          {successMsg && (
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 9, padding: '10px 12px', color: '#15803d', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 7 }}>
              {successMsg}
            </div>
          )}

        </div>
      </aside>

      {/* ── MAIN CONTENT ── */}
      <div className="go-main-col">

        {/* ── CARD 1 — Procedimiento y objeto ── */}
        <div className="go-fcard">
          <div className="go-fcard-head">
            <div className="go-fcard-badge" style={{ background: (procInfo && (!hasObjetos || objeto)) ? '#e7faf6' : undefined, color: (procInfo && (!hasObjetos || objeto)) ? '#0f766e' : undefined }}>
              {(procInfo && (!hasObjetos || objeto)) ? '✓' : '1'}
            </div>
            <div>
              <div className="go-fcard-title">Procedimiento y objeto</div>
              <div className="go-fcard-sub">Define qué anexos existen para tu oferta</div>
            </div>
            {procInfo && (
              <span className="go-chip-teal" style={{ marginLeft: 'auto' }}>
                {procInfo.label}{objetoInfo ? ` · ${objetoInfo.label}` : ''}
              </span>
            )}
          </div>
          <div className="go-fcard-body">
            <p className="go-sublabel">PROCEDIMIENTO</p>
            <div className="go-proc-grid">
              {PROCEDIMIENTOS.map(proc => {
                const isSel = procedimiento === proc.id;
                const disponible = proc.disponible !== false;
                return (
                  <button
                    key={proc.id}
                    onClick={() => handleSelectProcedimiento(proc.id)}
                    disabled={!disponible}
                    title={disponible ? undefined : 'Aún no disponible — plantillas en elaboración'}
                    className={`go-opt ${isSel ? 'go-opt--sel' : ''} ${!disponible ? 'go-opt--off' : ''}`}
                  >
                    <div className="go-opt-title">{isSel && <span aria-hidden="true">⊙ </span>}{proc.label}</div>
                    {disponible && <div className="go19-proc-sub">{proc.id.startsWith("licitacion") ? "Bienes · Obra" : "Servicios · Consultoría"}</div>}
                    {!disponible
                      ? <div className="go-opt-tag">Próximamente</div>
                      : null}
                  </button>
                );
              })}
            </div>

            {procedimiento && hasObjetos && (
              <>
                <p className="go-sublabel" style={{ marginTop: 16 }}>OBJETO DE CONTRATACIÓN</p>
                <div className="go19-objects">
                  {procInfo.objetos.map(obj => {
                    const isSel = objeto === obj.id;
                    const disponible = obj.disponible !== false;
                    return (
                      <button
                        key={obj.id}
                        onClick={() => handleSelectObjeto(obj.id)}
                        disabled={!disponible}
                        title={disponible ? undefined : 'Aún no disponible — plantillas en elaboración'}
                        className={`go-opt ${isSel ? 'go-opt--sel' : ''} ${!disponible ? 'go-opt--off' : ''}`}
                      >
                        <div className="go-opt-title">{isSel && "✓ "}{obj.label}</div>
                        {!disponible
                          ? <div className="go-opt-tag">Próximamente</div>
                          : null}
                      </button>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>

        {/* ── CARD 2 — Datos del procedimiento y modalidad ── */}
        {procedimiento && (!hasObjetos || objeto) && (
          <div className="go-fcard">
            <div className="go-fcard-head">
              <div className="go-fcard-badge" style={{ background: (formOferta.nomenclatura.trim() && formOferta.fecha_envio) ? '#e7faf6' : undefined, color: (formOferta.nomenclatura.trim() && formOferta.fecha_envio) ? '#0f766e' : undefined }}>
                {(formOferta.nomenclatura.trim() && formOferta.fecha_envio) ? '✓' : '2'}
              </div>
              <div>
                <div className="go-fcard-title">Datos del proceso y modalidad</div>
                <div className="go-fcard-sub">Nomenclatura, fecha y modalidad · se usan en todos los anexos</div>
              </div>
            </div>
            <div className="go-fcard-body go19-process">
              {/* Nomenclatura + fecha */}
              <div>
                <FormGroup>
                  <InputField label="Nomenclatura del proceso" name="nomenclatura" value={formOferta.nomenclatura} onChange={handleChange} placeholder="Ej: 001-2025-ENTIDAD" colSpan={2} required />
                  <InputField label="Fecha de envío" name="fecha_envio" type="date" value={formOferta.fecha_envio} onChange={handleChange} required />
                </FormGroup>
                {formOferta.fecha_envio && (() => {
                  const { dias, mes, anio } = splitFecha(formOferta.fecha_envio);
                  return <p className="go-hint">En los anexos: <strong style={{ color: '#0f766e' }}>{dias} de {mes} de {anio}</strong></p>;
                })()}
              </div>

              {/* Participación */}
              <div>
                <p className="go-sublabel">PARTICIPACIÓN</p>
                <div className="go-pillrow">
                  {MODALIDADES_PARTICIPACION.map(m => {
                    const isSel = modalidadParticipacion === m.id;
                    const disp = m.disponible !== false;
                    return (
                      <button key={m.id} disabled={!disp} title={disp ? undefined : 'Próximamente'} onClick={() => disp && setModalidadParticipacion(m.id)} className={`go-pill ${isSel ? 'go-pill--sel' : ''} ${!disp ? 'go-pill--off' : ''}`}>
                        {m.label}{!disp && <span className="go-mini-tag">Próximamente</span>}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Sistema de entrega */}
              <div>
                <p className="go-sublabel">SISTEMA DE ENTREGA</p>
                <div className="go-pillrow">
                  {['No aplica', 'Llave en mano'].map(opt => {
                    const isSel = sistemaEntrega === opt;
                    const off = sistemaEntregaOff(opt);
                    return (
                      <button key={opt} disabled={off} title={off ? 'Próximamente' : undefined} onClick={() => { if (!off) setSistemaEntrega(opt); }} className={`go-pill ${isSel ? 'go-pill--sel' : ''} ${off ? 'go-pill--off' : ''}`}>
                        {opt}{off && <span className="go-mini-tag">Próximamente</span>}
                      </button>
                    );
                  })}
                </div>
                {sistemaEntrega !== 'No aplica' && (
                  anexo12LlaveMano
                    ? <p className="go-note go-note--ok">Anexo 12 disponible. Al abrirlo eliges si se evalúa solo la entrega del bien o también la instalación.</p>
                    : <p className="go-note go-note--warn">Anexo 12 (Plazo de entrega) no disponible en esta modalidad.</p>
                )}
              </div>

              {/* Modalidad de pago */}
              <div>
                <p className="go-sublabel">MODALIDAD DE PAGO</p>
                <div className="go-pillrow">
                  {['Suma Alzada', 'Precios Unitarios'].map(opt => {
                    const isSel = modalidadPago === opt;
                    const off = modalidadPagoOff(opt);
                    return (
                      <button key={opt} disabled={off} title={off ? 'Próximamente' : undefined} onClick={() => { if (!off) setModalidadPago(opt); }} className={`go-pill ${isSel ? 'go-pill--sel' : ''} ${off ? 'go-pill--off' : ''}`}>
                        {opt}{off && <span className="go-mini-tag">Próximamente</span>}
                      </button>
                    );
                  })}
                </div>
                {modalidadPago === 'Precios Unitarios' && <p className="go-note go-note--info">Anexo 6 usará la plantilla de Precios Unitarios: concepto, cantidad, precio unitario y total.</p>}
                {modalidadPago === 'Esquema Mixto' && <p className="go-note go-note--warn">Anexo 6 (Oferta económica) no disponible en Esquema Mixto.</p>}
              </div>
              {esConsultoriaResumen && !esPreciosUnitarios && <p className="go-note go-note--info">ⓘ En Suma Alzada el <strong>Monto Ofertado</strong> es la suma de los ítems (IGV incluido); el Sub Total y el IGV se calculan hacia atrás en el Anexo 6.</p>}
            </div>
          </div>
        )}

        {/* ── CARD 3 — Anexos ── */}
        {procedimiento && (!hasObjetos || objeto) && (
          <div className={"go-fcard " + (anexosIncompletos.length ? "go19-pending" : "")}>
            <div className="go-fcard-head">
              <div className="go-fcard-badge" style={{ background: selCount > 0 ? '#e7faf6' : undefined, color: selCount > 0 ? '#0f766e' : undefined }}>
                {selCount > 0 && !anexosIncompletos.length ? '✓' : '3'}
              </div>
              <div>
                <div className="go-fcard-title">Anexos</div>
                <div className="go-fcard-sub">Solo se listan los que tienen plantilla para este procedimiento</div>
              </div>
              {selCount > 0 && (
                <span className="go-chip-teal" style={{ marginLeft: 'auto' }}>{selCount} marcados{anexosIncompletos.length > 0 ? ' · ' + anexosIncompletos.length + ' con datos pendientes' : ''}</span>
              )}
            </div>
            <div className="go-fcard-body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {Object.entries(GRUPOS_ANEXO).map(([grupoId, grupoLabel]) => {
                const grupoAnexos = anexosUI.filter(a => a.grupo === grupoId && anexoVisible(a.id));
                if (grupoAnexos.length === 0) return null;
                return (
                  <div key={grupoId}>
                    <p className="go-sublabel">{grupoLabel}</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {grupoAnexos.map(anexo => {
                        const disp = isAnexoDisponible(anexo.id);
                        const isSel = sel[anexo.id] && disp;
                        const pideDatos = ANEXOS_CON_DATOS.includes(anexo.id);
                        const completo = pideDatos && datosAnexoCompletos(anexo.id);
                        const abierto = modalAnexo === anexo.id;
                        return (
                          <div key={anexo.id} className={`go-anexo-wrap ${abierto ? 'go-anexo-wrap--open' : ''}`}>
                            <div className={`go-anexo ${isSel ? 'go-anexo--sel' : ''} ${!disp ? 'go-anexo--off' : ''} ${abierto ? 'go-anexo--open' : ''} ${isSel && pideDatos && !completo ? 'go19-anexo-pending' : ''}`}>
                              <input type="checkbox" className="go19-checkbox" aria-label={anexo.label} checked={!!isSel} disabled={!disp} onChange={() => toggleAnexo(anexo.id)} />
                              <div className="go-anexo-main" role={anexo.id === 'anexo6' ? 'button' : undefined} tabIndex={anexo.id === 'anexo6' && disp ? 0 : undefined} aria-disabled={!disp} onKeyDown={e => { if (anexo.id === 'anexo6' && disp && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); if (!isSel) setSel(prev => ({ ...prev, anexo6: true })); abrirAnexo('anexo6', e.currentTarget); } }} onClick={e => { if (anexo.id === 'anexo6' && disp) { if (!isSel) setSel(prev => ({ ...prev, anexo6: true })); abrirAnexo('anexo6', e.currentTarget); } else toggleAnexo(anexo.id); }}>
                                <div className="go-anexo-label">{anexo.label}</div>
                                <div className="go-anexo-desc">{anexo.descripcion}</div>
                              </div>
                              {!disp ? (
                                <span className="go-badge go-badge--off">No aplica</span>
                              ) : isSel && pideDatos ? (
                                <button type="button" onClick={e => { e.stopPropagation(); if (abierto) setModalAnexo(null); else abrirAnexo(anexo.id, e.currentTarget); }} className={`go-badge-btn ${abierto ? 'open' : completo ? 'ok' : 'warn'}`}>
                                  {abierto ? 'Cerrar ▲' : completo ? 'Datos completos · editar' : 'Completar datos ▾'}
                                </button>
                              ) : pideDatos ? (
                                <span className="go-badge go-badge--muted">Pide datos</span>
                              ) : (
                                <span className="go-badge go-badge--auto">Automático</span>
                              )}
                            </div>
                            {abierto && anexo.id !== 'anexo6' && (
                              <div className="go-anexo-panel">
                                <div className="go-anexo-panel-body">
                                  {renderDatosAnexoBody()}
                                </div>
                                <div className="go-anexo-panel-foot">
                                  <span className={`go-anexo-panel-status ${datosAnexoCompletos(anexo.id) ? 'ok' : 'warn'}`}>
                                    {datosAnexoCompletos(anexo.id) ? 'Datos completos' : 'Aún faltan datos por completar'}
                                  </span>
                                  <button type="button" onClick={() => setModalAnexo(null)} className="go-anexo-panel-done">Listo</button>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Barra de acción inferior */}
        {procedimiento && (!hasObjetos || objeto) && (
          <div className="go-actionbar">
            <div className={`go-actionbar__status ${listoParaGenerar ? 'ok' : 'warn'}`}>
              <span className="go-actionbar__chip">{listoParaGenerar ? '✓' : '!'}</span>
              {statusMsg}
            </div>
            <span className="go19-word-count">{selCount} anexos en un solo Word</span>
            <button className="go-actionbar__gen" onClick={generar} disabled={generando || !listoParaGenerar}>
              {generando ? (
                <><span className="go-spinner" />Generando…</>
              ) : (
                <><LhIcon name="download" size={16} />Generar Oferta (Word) <span className="go-actionbar__count">{selCount}</span></>
              )}
            </button>
          </div>
        )}


      </div>
    </div>
    </>
  );
};

/* ═══════════════════════════════════════════════════════════
   PÁGINA PRINCIPAL
══════════════════════════════════════════════════════════ */

const GeneradorOfertaPage = ({ user }) => {
  const [tab, setTab] = useState('generar');
  const [showHelp, setShowHelp] = useState(false);
  // null = verificando, true = permitido, false = sin acceso
  const [accesoPermitido, setAccesoPermitido] = useState(null);
  // Empresa del postor: se sincroniza con la cuenta del correo de la sesión.
  const { empresas, guardar, limpiar, cargando, enLaNube } = useEmpresas(user?.email);

  useEffect(() => {
    let cancelado = false;

    // ADMI siempre tiene acceso
    if (String(user?.plan || '').trim().toUpperCase() === 'ADMI') {
      setAccesoPermitido(true);
      return;
    }

    obtenerConfiguracionAccesos()
      .then(({ generadorPlanes, grupos }) => {
        if (cancelado) return;
        setAccesoPermitido(
          hasGeneradorAccess(user?.plan, user?.curso_tipo, generadorPlanes, grupos)
        );
      })
      .catch(() => { if (!cancelado) setAccesoPermitido(false); });

    return () => { cancelado = true; };
  }, [user]);

  if (accesoPermitido === null) {
    return (
      <Container fluid className="py-5 d-flex flex-column align-items-center justify-content-center"
        style={{ background: '#f1f5f9', minHeight: '100vh' }}>
        <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Cargando...</span>
        </div>
        <p className="text-muted mb-0">Verificando acceso…</p>
      </Container>
    );
  }

  if (!accesoPermitido) {
    return (
      <Container fluid className="py-5 d-flex align-items-center justify-content-center"
        style={{ background: '#f1f5f9', minHeight: '100vh' }}>
        <div style={{
          background: 'white', borderRadius: 16, padding: '3rem 2.5rem', maxWidth: 480,
          textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.08)'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔒</div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0f172a', marginBottom: '0.75rem' }}>
            No tienes acceso a esta sección
          </h2>
          <p style={{ color: '#64748b', margin: 0, lineHeight: 1.6 }}>
            El Generador de Oferta no está disponible para tu plan. Si crees que
            deberías tener acceso, comunícate con el administrador.
          </p>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="go19-page">

      <header className="go19-header"><div><div className="go19-eyebrow">SEACE · DOCUMENTOS DE OFERTA</div><h1>Generar Oferta</h1><p>Registra tu empresa una vez y genera los anexos de cualquier procedimiento en un solo Word</p></div><div className="go19-header-actions"><nav className="go19-tabs" aria-label="Sección de ofertas">{[{ id: 'empresa', label: 'Mi Empresa', icon: 'building' }, { id: 'generar', label: 'Generar Oferta', icon: 'file' }].map(t => <button type="button" key={t.id} aria-pressed={tab === t.id} onClick={() => setTab(t.id)}><LhIcon name={t.icon} size={14} />{t.label}</button>)}</nav><button type="button" className="go19-secondary" aria-expanded={showHelp} aria-controls="go19-help" onClick={() => setShowHelp(v => !v)}><LhIcon name="info" size={14} />Cómo funciona</button></div></header>
      {showHelp && <div id="go19-help" className="go19-help"><strong>Tu oferta en tres pasos</strong><ol><li>Registra y guarda los datos del postor en Mi Empresa.</li><li>Selecciona el procedimiento, objeto, fecha y modalidad de tu proceso.</li><li>Marca los anexos, completa los datos pendientes y descarga tu oferta en Word.</li></ol></div>}

      {tab === 'empresa' && <RegistrarEmpresa empresas={empresas} onSave={guardar} onClear={limpiar} cargando={cargando} enLaNube={enLaNube} />}
      <div hidden={tab !== 'generar'}><GenerarOferta goToEmpresa={() => setTab('empresa')} empresas={empresas} /></div>

      <style>{`
        /* ── Grilla responsive ── */
        .go-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 0.9rem;
        }
        .go-col2 { grid-column: span 2; }
        @media (max-width: 560px) {
          .go-col2 { grid-column: span 1; }
          .go-grid { grid-template-columns: 1fr; }
        }

        /* ── Campos ── */
        .go-field-label {
          display: block; font-size: 0.74rem; font-weight: 700;
          color: #374151; margin-bottom: 5px; letter-spacing: 0.02em;
        }
        .go-input {
          width: 100%; padding: 9px 12px;
          border: 1.5px solid #e2e8f0; border-radius: 8px;
          font-size: 0.875rem; color: #111827; outline: none;
          box-sizing: border-box; background: white;
          transition: border-color 0.15s, box-shadow 0.15s;
        }
        .go-input:disabled { background: #f9fafb; color: #9ca3af; }
        .go-select {
          cursor: pointer; appearance: none; padding-right: 32px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
          background-repeat: no-repeat; background-position: right 10px center;
        }

        /* ── Cards ── */
        .go-card {
          background: white; border-radius: 12px;
          border: 1px solid #e5e7eb; padding: 20px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.04);
        }
        .go-step-card {
          background: white; border-radius: 12px;
          border: 1.5px solid #e5e7eb; overflow: hidden;
          box-shadow: 0 1px 4px rgba(0,0,0,0.04);
          transition: border-color 0.2s;
        }
        .go-step-header {
          padding: 14px 20px; background: #fafafa;
          border-bottom: 1px solid #f1f5f9;
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 10px;
        }
        .go-step-num {
          width: 28px; height: 28px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          color: white; font-weight: 700; font-size: 13px;
          flex-shrink: 0; background: #0d9488;
        }
        .go-anexo-header {
          display: flex; align-items: center; gap: 12px;
          padding: 14px 20px; border-bottom: 1px solid #f1f5f9;
        }

        /* ── Section block ── */
        .go-section-block {
          display: flex; align-items: center; gap: 12px;
          padding-bottom: 14px; border-bottom: 1px solid #f8fafc;
          margin-bottom: 2px;
        }
        .go-divider {
          border: none; border-top: 1px solid #f1f5f9;
          margin: 20px 0;
        }

        /* ── Type selector ── */
        .go-type-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
        @media (max-width: 380px) { .go-type-grid { grid-template-columns: 1fr; } }
        .go-type-btn {
          display: flex; align-items: center; gap: 12px; padding: 14px 16px;
          border-radius: 10px; border: 1.5px solid #e5e7eb;
          background: #fafafa; cursor: pointer; text-align: left;
          transition: all 0.15s; box-shadow: 0 1px 3px rgba(0,0,0,0.04);
        }
        .go-type-btn:hover { border-color: #5eead4; background: #e7faf6; }
        .go-type-btn--active {
          border-color: #0d9488 !important; background: #e7faf6 !important;
          box-shadow: 0 2px 10px rgba(13,148,136,0.15) !important;
        }

        /* ── Empresa card ── */
        .go-empresa-header {
          display: flex; align-items: flex-start;
          justify-content: space-between; flex-wrap: wrap; gap: 14px;
        }
        .go-empresa-badge {
          display: flex; align-items: center; gap: 10px;
          border-radius: 10px; padding: 10px 16px;
        }
        .go-empresa-badge--ok {
          background: #f0fdf4; border: 1px solid #bbf7d0;
          max-width: 260px;
        }
        .go-empresa-badge--warn {
          background: #fffbeb; border: 1px solid #fde047;
          font-size: 13px; color: #92400e;
        }

        /* ── Saved banner ── */
        .go-saved-banner {
          background: #f0fdf4; border-radius: 10px;
          padding: 12px 16px; border: 1px solid #bbf7d0;
          display: flex; align-items: center;
          justify-content: space-between; gap: 12px;
        }

        /* ── Procedure grid ── */
        .go-proc-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
          gap: 10px;
        }
        @media (max-width: 480px) { .go-proc-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 300px) { .go-proc-grid { grid-template-columns: 1fr; } }

        /* ── Stepper labels ── */
        .go-step-label {}
        @media (max-width: 400px) { .go-step-label { display: none; } }

        /* ── Tabs ── */
        .go-tabs-wrapper { margin-bottom: 1.25rem; }
        .go-tabs {
          display: inline-flex; gap: 6px; background: white;
          border-radius: 12px; padding: 5px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 1px 4px rgba(0,0,0,0.05);
        }
        @media (max-width: 480px) {
          .go-tabs { display: flex; width: 100%; }
          .go-tab-btn { flex: 1; justify-content: center !important; }
        }
        .go-tab-btn {
          position: relative;
          padding: 10px 24px; border-radius: 9px; font-weight: 600;
          font-size: 14px; cursor: pointer; border: none;
          background: transparent; color: #64748b;
          display: flex; align-items: center; gap: 8px;
          transition: color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease;
        }
        .go-tab-btn span:first-child {
          font-size: 16px; line-height: 1;
          transition: transform 0.18s ease;
        }
        .go-tab-btn:hover:not(.go-tab-btn--active) {
          background: #ecfdf9; color: #0d9488;
        }
        .go-tab-btn:hover:not(.go-tab-btn--active) span:first-child {
          transform: scale(1.12);
        }
        .go-tab-btn:active { transform: translateY(1px); }
        .go-tab-btn:focus-visible {
          outline: 2px solid #5eead4; outline-offset: 2px;
        }
        .go-tab-btn--active {
          background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%) !important;
          color: white !important;
          font-weight: 700 !important;
          box-shadow: 0 4px 12px rgba(13,148,136,0.35) !important;
        }

        /* ── Format grid ── */
        .go-format-grid { display: grid; grid-template-columns: 1fr 1fr; }
        @media (max-width: 400px) {
          .go-format-grid { grid-template-columns: 1fr; }
          .go-format-btn { border-left: none !important; border-top: 1px solid #f1f5f9; }
        }
        .go-format-btn {
          padding: 26px 20px; border: none; background: white; cursor: pointer;
          display: flex; flex-direction: column; align-items: center; gap: 10px;
          transition: background 0.15s;
        }

        /* ── Buttons ── */
        .go-btn-primary {
          padding: 11px 28px; border-radius: 10px; border: none;
          background: #0d9488; color: white;
          font-size: 14px; font-weight: 700; cursor: pointer;
          display: flex; align-items: center; gap: 8px;
          box-shadow: 0 4px 14px rgba(13,148,136,0.28);
          transition: all 0.2s;
        }
        .go-btn-primary:hover { background: #0f766e; box-shadow: 0 6px 18px rgba(13,148,136,0.35); transform: translateY(-1px); }
        .go-btn-primary:active { transform: translateY(0); }

        .go-btn-danger-sm {
          background: none; border: 1px solid #fca5a5; color: #ef4444;
          border-radius: 8px; padding: 6px 14px; font-size: 12px;
          font-weight: 600; cursor: pointer; white-space: nowrap;
          transition: all 0.15s; flex-shrink: 0;
        }
        .go-btn-danger-sm:hover { background: #fef2f2; }

        .go-btn-generar {
          width: 100%; height: 52px; border-radius: 12px; border: none;
          background: #0d9488; color: white;
          font-weight: 700; font-size: 15px; cursor: pointer;
          display: flex; align-items: center; justify-content: center; gap: 10px;
          box-shadow: 0 4px 18px rgba(13,148,136,0.32);
          transition: all 0.2s;
        }
        .go-btn-generar:hover:not(:disabled) {
          background: #0f766e; transform: translateY(-1px);
          box-shadow: 0 6px 22px rgba(13,148,136,0.4);
        }

        /* ── Spinner ── */
        .go-spinner {
          width: 17px; height: 17px; border-radius: 50%;
          border: 2px solid rgba(255,255,255,0.3);
          border-top-color: white; display: inline-block;
          animation: go-spin 0.7s linear infinite;
        }
        @keyframes go-spin { to { transform: rotate(360deg); } }

        /* ══ Mi Empresa — Rediseño (lh-*) ══ */
        .lh-layout {
          display: grid;
          grid-template-columns: 256px 1fr;
          gap: 22px;
          align-items: start;
          background: linear-gradient(180deg, #eef4f5 0%, #f4f7fb 100%);
          border-radius: 20px;
          padding: 22px;
          margin: -4px;
        }
        @media (max-width: 540px) { .lh-layout { padding: 14px; } }
        @media (max-width: 860px) {
          .lh-layout { grid-template-columns: 1fr; }
          .lh-aside-sticky { position: static !important; }
        }
        .lh-aside-sticky {
          position: sticky; top: 20px;
          display: flex; flex-direction: column; gap: 13px;
        }

        /* Progress card */
        .lh-prog-card {
          background: linear-gradient(140deg, #0f766e 0%, #0d9488 55%, #14b8a6 100%);
          border: none; color: white;
          border-radius: 14px; padding: 18px 20px 20px;
          box-shadow: 0 8px 22px rgba(13,148,136,0.28);
        }
        .lh-prog-card .lh-prog-label { color: rgba(255,255,255,0.85); }
        .lh-prog-card .lh-prog-pct { color: white; }
        .lh-prog-card .lh-prog-track { background: rgba(255,255,255,0.22); }
        .lh-prog-card .lh-prog-fill { background: white; }
        .lh-prog-card .lh-prog-note { color: rgba(255,255,255,0.92); }
        .lh-prog-card .lh-prog-note b { color: white !important; }
        .lh-prog-head {
          display: flex; align-items: baseline;
          justify-content: space-between; margin-bottom: 11px;
        }
        .lh-prog-label { font-size: 0.73rem; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; }
        .lh-prog-pct { font-size: 1.4rem; font-weight: 700; color: #0d9488; line-height: 1; }
        .lh-prog-track { height: 8px; border-radius: 999px; background: #f1f3f9; overflow: hidden; }
        .lh-prog-fill {
          height: 100%; border-radius: 999px;
          background: linear-gradient(90deg, #0d9488 0%, #14b8a6 100%);
          transition: width 0.5s cubic-bezier(.4,0,.2,1);
        }
        .lh-prog-note { font-size: 0.78rem; color: #64748b; margin-top: 11px; line-height: 1.45; }

        /* Stepper */
        .lh-stepper {
          background: white; border: 1px solid #e3e8f0;
          border-radius: 14px; padding: 7px 5px;
          box-shadow: 0 4px 14px rgba(15,23,42,0.06);
        }
        .lh-step {
          display: flex; gap: 11px; padding: 10px 11px;
          border-radius: 9px; cursor: pointer;
          transition: background 0.13s; position: relative;
        }
        .lh-step:hover { background: #f6f7fb; }
        .lh-step--active { background: #e7faf6 !important; }
        .lh-step-num {
          width: 27px; height: 27px; border-radius: 50%; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          font-size: 0.83rem; font-weight: 700;
          background: #eceff5; color: #64748b; transition: all 0.18s;
        }
        .lh-step--active .lh-step-num { background: #0d9488; color: white; }
        .lh-step--done   .lh-step-num { background: #ecfdf3; color: #16a34a; }
        .lh-step-title { font-size: 0.86rem; font-weight: 600; color: #16203a; line-height: 1.25; }
        .lh-step--active .lh-step-title { color: #0f766e; }
        .lh-step-sub { font-size: 0.73rem; color: #64748b; margin-top: 1px; }
        .lh-step-line {
          position: absolute; left: 24px; top: 48px;
          width: 2px; height: 12px; background: #e5e7eb;
        }

        /* Trust */
        .lh-trust {
          display: flex; gap: 10px; align-items: flex-start;
          background: #f0fdfa; border: 1px solid #ccefe9;
          border-radius: 14px; padding: 13px 15px;
          box-shadow: 0 4px 14px rgba(15,23,42,0.05);
        }
        .lh-trust-ico { color: #0d9488; flex-shrink: 0; margin-top: 1px; }
        .lh-trust p { font-size: 0.78rem; color: #64748b; line-height: 1.5; }
        .lh-trust b { color: #16203a; font-weight: 600; }

        /* Form column */
        .lh-form-col { display: flex; flex-direction: column; gap: 16px; }

        /* Form card */
        .lh-fcard {
          position: relative;
          background: white; border: 1px solid #e3e8f0;
          border-radius: 16px; overflow: hidden;
          box-shadow: 0 4px 16px rgba(15,23,42,0.06), 0 1px 3px rgba(15,23,42,0.04);
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        .lh-fcard::before {
          content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
          background: linear-gradient(90deg, #0d9488 0%, #14b8a6 50%, #5eead4 100%);
          opacity: 0.85;
        }
        .lh-fcard:hover {
          box-shadow: 0 10px 30px rgba(13,148,136,0.10), 0 2px 6px rgba(15,23,42,0.05);
        }
        .lh-fcard-head {
          display: flex; align-items: center; gap: 13px;
          padding: 20px 26px; border-bottom: 1px solid #e9eef5;
          background: linear-gradient(180deg, #f5fbfa 0%, #ffffff 100%);
          flex-wrap: wrap;
        }
        .lh-fcard-badge {
          width: 38px; height: 38px; border-radius: 11px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          font-size: 1rem; font-weight: 800; color: white;
          background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%);
          box-shadow: 0 4px 12px rgba(13,148,136,0.3);
        }
        .lh-fcard-title { font-size: 1.05rem; font-weight: 700; color: #16203a; letter-spacing: -0.1px; }
        .lh-fcard-sub { font-size: 0.82rem; color: #64748b; margin-top: 2px; }
        .lh-fcard-body { padding: 22px 26px; }
        .lh-req-legend { font-size: 0.76rem; color: #64748b; margin-left: auto; display: flex; align-items: center; gap: 4px; }

        /* Type selector */
        .lh-type-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 13px; }
        @media (max-width: 540px) { .lh-type-grid { grid-template-columns: 1fr; } }
        .lh-type-card {
          display: flex; align-items: center; gap: 13px;
          padding: 17px 19px; border-radius: 12px; cursor: pointer;
          border: 2px solid #dfe4ec; background: white;
          font-family: inherit; text-align: left; transition: all 0.15s;
        }
        .lh-type-card:hover { border-color: #5eead4; background: #fafbfd; }
        .lh-type-card--sel {
          border-color: #0d9488 !important; background: #e7faf6 !important;
          box-shadow: 0 5px 18px rgba(13,148,136,0.13) !important;
        }
        .lh-type-ico {
          width: 46px; height: 46px; border-radius: 11px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          background: #f1f3f9; color: #64748b; transition: all 0.15s;
        }
        .lh-type-ico--sel { background: #0d9488 !important; color: white !important; }
        .lh-type-check {
          width: 21px; height: 21px; border-radius: 50%; margin-left: auto; flex-shrink: 0;
          border: 2px solid #cbd2de; display: flex; align-items: center; justify-content: center;
          color: white; transition: all 0.15s;
        }
        .lh-type-check--sel { background: #0d9488 !important; border-color: #0d9488 !important; }

        /* Field grid */
        .lh-field-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 18px 20px; }
        .lh-field-grid--3 { grid-template-columns: 1fr 1fr 1fr; }
        .lh-col-full { grid-column: 1 / -1; }
        @media (max-width: 640px) {
          .lh-field-grid, .lh-field-grid--3 { grid-template-columns: 1fr; }
          .lh-col-full { grid-column: span 1; }
        }

        /* Field */
        .lh-field { display: flex; flex-direction: column; }
        .lh-field-label {
          display: flex; align-items: center; gap: 4px;
          font-size: 0.88rem; font-weight: 600; color: #16203a; margin-bottom: 6px;
        }
        .lh-opt { font-size: 0.73rem; font-weight: 500; color: #94a3b8; }
        .lh-input-wrap { position: relative; }
        .lh-input-ico {
          position: absolute; left: 13px; top: 50%; transform: translateY(-50%);
          color: #94a3b8; pointer-events: none; display: flex; transition: color 0.15s;
        }
        .lh-field-input {
          width: 100%; height: 50px; padding: 0 40px 0 42px;
          font-family: inherit; font-size: 0.95rem; color: #16203a;
          background: #fbfcfe; border: 1.5px solid #dfe4ec; border-radius: 10px;
          outline: none; box-sizing: border-box;
          transition: border-color 0.15s, box-shadow 0.15s;
        }
        .lh-field-select {
          appearance: none; cursor: pointer; padding-right: 34px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
          background-repeat: no-repeat; background-position: right 12px center;
        }
        .lh-field-input::placeholder { color: #aab3c2; }
        .lh-field-input:hover { border-color: #5eead4; }
        .lh-field-input:focus { border-color: #0d9488; background: white; box-shadow: 0 0 0 4px rgba(13,148,136,0.1); }
        .lh-input-wrap:focus-within .lh-input-ico { color: #0d9488; }
        .lh-valid-tick {
          position: absolute; right: 13px; top: 50%; transform: translateY(-50%);
          color: #16a34a; display: flex; opacity: 0; transition: opacity 0.18s;
        }
        .lh-valid-tick--show { opacity: 1; }
        .lh-field-help { font-size: 0.76rem; color: #64748b; margin-top: 5px; line-height: 1.4; }
        .lh-field-help--warn { color: #b45309 !important; }

        /* Save bar */
        .lh-fieldset { border: 0; padding: 0; margin: 0; min-width: 0; }
        .lh-sync-note {
          margin: 18px 0 8px; font-size: 0.78rem; color: #64748b;
          display: flex; align-items: center; gap: 6px;
        }
        .lh-savebar {
          position: sticky; bottom: 14px;
          display: flex; align-items: center; gap: 14px; flex-wrap: wrap;
          background: rgba(255,255,255,0.92); backdrop-filter: blur(8px);
          border: 1px solid #d7e0ec;
          border-radius: 14px; padding: 13px 18px;
          box-shadow: 0 8px 26px rgba(15,23,42,0.12);
        }
        .lh-save-status {
          display: flex; align-items: center; gap: 8px;
          font-size: 0.88rem; font-weight: 500;
        }
        .lh-save-chip {
          width: 25px; height: 25px; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
        }
        .lh-save-chip--warn { background: #fef3c7; color: #b45309; }
        .lh-save-chip--ok   { background: #ecfdf3; color: #16a34a; }
        .lh-save-status--incomplete { color: #926710; }
        .lh-save-status--ready      { color: #16a34a; }
        .lh-btn-save {
          margin-left: auto; display: inline-flex; align-items: center; gap: 8px;
          padding: 11px 24px; border-radius: 10px; border: none; cursor: pointer;
          font-family: inherit; font-size: 0.95rem; font-weight: 700; color: white;
          background: #0d9488; transition: all 0.15s;
          box-shadow: 0 4px 14px rgba(13,148,136,0.28);
        }
        .lh-btn-save:hover { background: #0f766e; transform: translateY(-1px); box-shadow: 0 6px 18px rgba(13,148,136,0.35); }
        .lh-btn-save:active { transform: translateY(0); }
        .lh-btn-save:disabled { opacity: 0.55; cursor: not-allowed; box-shadow: none; transform: none; }
        .lh-savebar-actions { margin-left: auto; display: flex; align-items: center; gap: 10px; }
        .lh-btn-clear {
          display: inline-flex; align-items: center; gap: 7px;
          padding: 10px 17px; border-radius: 10px; cursor: pointer;
          border: 1px solid #e7cdc9; background: white; color: #b42318;
          font-family: inherit; font-size: 0.9rem; font-weight: 600;
          transition: background-color 0.15s, border-color 0.15s, color 0.15s;
        }
        .lh-btn-clear:hover:not(:disabled) { background: #fef3f2; border-color: #d9a29b; }
        .lh-btn-clear:disabled { opacity: 0.45; cursor: not-allowed; }
        .lh-btn-clear--firm { background: #b42318; border-color: #b42318; color: white; }
        .lh-btn-clear--firm:hover:not(:disabled) { background: #96190f; border-color: #96190f; }
        .lh-btn-ghost {
          display: inline-flex; align-items: center;
          padding: 10px 15px; border-radius: 10px; cursor: pointer;
          border: 1px solid #d7e0ec; background: white; color: #475569;
          font-family: inherit; font-size: 0.9rem; font-weight: 600;
          transition: background-color 0.15s, border-color 0.15s;
        }
        .lh-btn-ghost:hover:not(:disabled) { background: #f1f5f9; }
        .lh-btn-ghost:disabled { opacity: 0.45; cursor: not-allowed; }
        .lh-save-chip--danger { background: #fef3f2; color: #b42318; }
        .lh-save-status--danger { color: #b42318; }

        /* ══ Generar Oferta — layout sidebar ══ */
        .go-layout {
          display: grid;
          grid-template-columns: 244px 1fr;
          gap: 20px;
          align-items: start;
        }
        @media (max-width: 860px) {
          .go-layout { grid-template-columns: 1fr; }
          .go-aside-sticky { position: static !important; }
        }
        .go-aside-sticky {
          position: sticky; top: 20px;
          display: flex; flex-direction: column; gap: 12px;
        }
        .go-main-col { display: flex; flex-direction: column; gap: 14px; }

        /* Summary card */
        .go-sum-card {
          background: white; border: 1px solid #e5e7eb;
          border-radius: 14px; overflow: hidden;
          box-shadow: 0 1px 3px rgba(0,0,0,0.04);
        }
        .go-sum-head {
          padding: 12px 16px; background: #f8fafc;
          border-bottom: 1px solid #f1f5f9;
          font-size: 0.73rem; font-weight: 700; color: #64748b;
          text-transform: uppercase; letter-spacing: 0.5px;
        }

        /* Form cards (go-fcard) */
        .go-fcard {
          position: relative;
          background: white; border: 1px solid #e3e8f0;
          border-radius: 16px; overflow: hidden;
          box-shadow: 0 4px 16px rgba(15,23,42,0.06), 0 1px 3px rgba(15,23,42,0.04);
          transition: box-shadow 0.2s ease;
        }
        .go-fcard:hover {
          box-shadow: 0 10px 30px rgba(13,148,136,0.10), 0 2px 6px rgba(15,23,42,0.05);
        }
        .go-fcard-head {
          display: flex; align-items: center; gap: 13px;
          padding: 16px 20px; border-bottom: 1px solid #e9eef5;
          flex-wrap: wrap; background: linear-gradient(180deg, #f5fbfa 0%, #ffffff 100%);
        }
        .go-fcard-badge {
          width: 32px; height: 32px; border-radius: 9px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          font-size: 0.88rem; font-weight: 700;
          background: #e7faf6; color: #0d9488;
          transition: all 0.2s;
        }
        .go-fcard-title { font-size: 0.97rem; font-weight: 700; color: #111827; line-height: 1.3; }
        .go-fcard-sub { font-size: 0.79rem; color: #64748b; margin-top: 2px; }
        .go-fcard-body { padding: 18px 20px; }

        /* ── Sistema visual 8a (acento teal único) ── */
        .go-chip-teal {
          font-size: 12px; font-weight: 700; color: #0f766e;
          background: #e7faf6; border: 1px solid #99f6e4; border-radius: 20px;
          padding: 4px 12px; white-space: nowrap;
        }
        .go-sublabel { margin: 0 0 8px; font-size: 11px; font-weight: 700; letter-spacing: 0.05em; color: #94a3b8; text-transform: uppercase; }
        .go-hint { margin: 2px 0 0; font-size: 12px; color: #94a3b8; }

        .go-opt {
          position: relative; padding: 12px 14px; border-radius: 10px; text-align: left;
          border: 1.5px solid #e5e7eb; background: #fafafa; cursor: pointer; transition: all 0.15s;
        }
        .go-opt:hover:not(:disabled):not(.go-opt--sel) { background: #f3f7f6; border-color: #cbd5e1; }
        .go-opt--sel { background: #f0fdfa; border: 2px solid #0d9488; box-shadow: 0 3px 12px rgba(13,148,136,0.15); }
        .go-opt--off { background: #f3f4f6; border: 1.5px dashed #d1d5db; cursor: not-allowed; opacity: 0.65; }
        .go-opt-title { font-size: 12.5px; font-weight: 700; color: #26303f; line-height: 1.3; }
        .go-opt--sel .go-opt-title { color: #0f766e; }
        .go-opt--off .go-opt-title { color: #9ca3af; }
        .go-opt-tag { margin-top: 6px; font-size: 10px; font-weight: 700; color: #9ca3af; }
        .go-opt-tag--sel { color: #0d9488; display: inline-flex; align-items: center; gap: 5px; }
        .go-dot { width: 5px; height: 5px; border-radius: 50%; background: #0d9488; display: inline-block; }

        .go-pillrow { display: flex; gap: 8px; flex-wrap: wrap; }
        .go-pill {
          display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 9px;
          border: 1.5px solid #e5e7eb; background: #f8fafc; color: #6b7280; font-size: 13px; font-weight: 600;
          cursor: pointer; transition: all 0.15s;
        }
        .go-pill:hover:not(:disabled):not(.go-pill--sel) { background: #f0fdfa; border-color: #99f6e4; color: #0f766e; }
        .go-pill--sel { background: #e7faf6; border: 2px solid #0d9488; color: #0f766e; box-shadow: 0 2px 8px rgba(13,148,136,0.12); }
        .go-pill--off { color: #cbd5e1; cursor: not-allowed; opacity: 0.6; }
        .go-mini-tag { font-size: 10px; font-weight: 700; color: #94a3b8; background: #f1f5f9; border: 1px solid #e2e8f0; border-radius: 999px; padding: 1px 7px; text-transform: uppercase; letter-spacing: 0.04em; }

        .go-note { margin: 8px 0 0; font-size: 12px; border-radius: 8px; padding: 7px 11px; line-height: 1.45; }
        .go-note--ok { color: #0f766e; background: #e7faf6; border: 1px solid #5eead4; }
        .go-note--warn { color: #b45309; background: #fffbeb; border: 1px solid #fde68a; }
        .go-note--info { color: #0369a1; background: #f0f9ff; border: 1px solid #bae6fd; }

        .go-anexo {
          display: flex; align-items: center; gap: 12px; padding: 11px 14px; border-radius: 10px;
          cursor: pointer; transition: all 0.15s; user-select: none; background: #fff; border: 1.5px solid #e5e7eb;
        }
        .go-anexo:hover:not(.go-anexo--off) { background: #f7fbfa; }
        .go-anexo--sel { background: #f0fdfa; border: 1.5px solid #0d9488; box-shadow: 0 2px 8px rgba(13,148,136,0.10); }
        .go-anexo--off { background: #fafafa; border: 1.5px dashed #e5e7eb; opacity: 0.6; cursor: default; }
        .go-anexo-check {
          width: 20px; height: 20px; border-radius: 6px; flex-shrink: 0; border: 1.5px solid #d1d5db; background: #fff;
          display: flex; align-items: center; justify-content: center; color: #fff; font-size: 11px; font-weight: 800; transition: all 0.15s;
        }
        .go-anexo--sel .go-anexo-check { background: #0d9488; border-color: #0d9488; }
        .go-anexo-main { flex: 1; min-width: 0; }
        .go-anexo-label { font-size: 13px; font-weight: 700; color: #111827; }
        .go-anexo--sel .go-anexo-label { color: #0f766e; }
        .go-anexo--off .go-anexo-label { color: #6b7280; }
        .go-anexo-desc { font-size: 12px; color: #9ca3af; margin-top: 2px; }
        .go-badge { font-size: 11px; font-weight: 700; border-radius: 20px; padding: 3px 10px; flex-shrink: 0; white-space: nowrap; }
        .go-badge--auto { color: #0f766e; background: #e7faf6; }
        .go-badge--muted { color: #64748b; background: #f1f5f9; }
        .go-badge--off { color: #9ca3af; background: #f3f4f6; }
        .go-badge-btn { font-size: 11px; font-weight: 700; border-radius: 20px; padding: 5px 12px; flex-shrink: 0; white-space: nowrap; cursor: pointer; border: none; transition: all 0.15s; }
        .go-badge-btn.warn { color: #fff; background: #0d9488; }
        .go-badge-btn.warn:hover { background: #0f766e; }
        .go-badge-btn.ok { color: #0f766e; background: #e7faf6; border: 1px solid #99f6e4; }
        .go-badge-btn.open { color: #fff; background: #0f766e; }

        /* Panel de datos del anexo (en línea, sin modal) */
        .go-anexo-wrap { border-radius: 10px; }
        .go-anexo-wrap--open .go-anexo { border-color: #0d9488; border-bottom-color: transparent; border-bottom-left-radius: 0; border-bottom-right-radius: 0; }
        .go-anexo--open { background: #f0fdfa; box-shadow: 0 2px 8px rgba(13,148,136,0.10); }
        .go-anexo-panel {
          border: 1.5px solid #0d9488; border-top: none;
          border-radius: 0 0 10px 10px; background: #fbfdfd; overflow: hidden;
          animation: goAnexoDown 0.18s ease;
        }
        @keyframes goAnexoDown { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: none; } }
        .go-anexo-panel-body { padding: 16px; display: flex; flex-direction: column; gap: 14px; }
        .go-anexo-panel-foot {
          display: flex; align-items: center; justify-content: space-between; gap: 10px;
          padding: 12px 16px; border-top: 1px solid #d7ece9; background: #f5fbfa;
        }
        .go-anexo-panel-status { font-size: 12px; font-weight: 600; }
        .go-anexo-panel-status.ok { color: #0f766e; }
        .go-anexo-panel-status.warn { color: #b45309; }
        .go-anexo-panel-done { border: none; background: #0d9488; color: #fff; border-radius: 9px; padding: 8px 20px; font-size: 13px; font-weight: 700; cursor: pointer; transition: background 0.15s; }
        .go-anexo-panel-done:hover { background: #0f766e; }

        /* Trust note */
        .go-trust-note {
          display: flex; gap: 9px; align-items: flex-start;
          background: white; border: 1px solid #e5e7eb;
          border-radius: 12px; padding: 12px 14px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.04);
        }
        .go-trust-note p { font-size: 0.77rem; color: #64748b; line-height: 1.5; margin: 0; }

        /* Progreso (sidebar) */
        .go-sum-label { font-size: 11px; font-weight: 700; color: #94a3b8; letter-spacing: 0.05em; margin-bottom: 10px; }
        .go-progress { display: flex; flex-direction: column; gap: 3px; }
        .go-prog-step { display: flex; gap: 10px; align-items: flex-start; }
        .go-prog-dot {
          width: 20px; height: 20px; border-radius: 50%; flex-shrink: 0; margin-top: 1px;
          display: flex; align-items: center; justify-content: center;
          font-size: 11px; font-weight: 800; color: #fff; background: #cbd5e1;
        }
        .go-prog-step.done .go-prog-dot { background: #0d9488; }
        .go-prog-step.warn .go-prog-dot { background: #f59e0b; }
        .go-prog-title { font-size: 12.5px; font-weight: 700; color: #16203a; line-height: 1.25; }
        .go-prog-step.todo .go-prog-title { color: #94a3b8; }
        .go-prog-sub { font-size: 11px; color: #64748b; margin-top: 1px; line-height: 1.3; }
        .go-prog-step.warn .go-prog-sub { color: #b45309; font-weight: 600; }

        /* Barra de acción inferior */
        .go-actionbar {
          position: sticky; bottom: 14px;
          display: flex; align-items: center; gap: 14px; flex-wrap: wrap;
          background: rgba(255,255,255,0.94); backdrop-filter: blur(8px);
          border: 1px solid #d7e0ec; border-radius: 14px;
          padding: 12px 16px; margin-top: 2px;
          box-shadow: 0 8px 26px rgba(15,23,42,0.12);
        }
        .go-actionbar__status { display: flex; align-items: center; gap: 9px; font-size: 13px; font-weight: 600; flex: 1; min-width: 200px; }
        .go-actionbar__status.ok { color: #16a34a; }
        .go-actionbar__status.warn { color: #b45309; }
        .go-actionbar__chip { width: 24px; height: 24px; border-radius: 7px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 12px; }
        .go-actionbar__status.ok .go-actionbar__chip { background: #ecfdf3; }
        .go-actionbar__status.warn .go-actionbar__chip { background: #fef3c7; }
        .go-actionbar__gen {
          display: inline-flex; align-items: center; gap: 9px;
          border: none; cursor: pointer; border-radius: 10px;
          padding: 11px 22px; font-size: 14px; font-weight: 700; color: #fff;
          background: #0d9488; box-shadow: 0 4px 14px rgba(13,148,136,0.3);
          transition: all 0.18s;
        }
        .go-actionbar__gen:hover:not(:disabled) { background: #0f766e; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(13,148,136,0.4); }
        .go-actionbar__gen:disabled { opacity: 0.6; cursor: not-allowed; }
        .go-actionbar__count { background: rgba(255,255,255,0.22); border-radius: 6px; padding: 2px 8px; font-size: 12px; }

        /* Toast */
        .lh-toast {
          position: fixed; bottom: 24px; left: 50%;
          transform: translateX(-50%) translateY(20px);
          background: #16203a; color: white;
          padding: 12px 20px; border-radius: 11px;
          font-size: 0.9rem; font-weight: 600;
          display: flex; align-items: center; gap: 8px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.22);
          opacity: 0; pointer-events: none;
          transition: all 0.28s ease; z-index: 9999;
        }
        .lh-toast--show { opacity: 1; transform: translateX(-50%) translateY(0); }
      `}</style>
    </Container>
  );
};

export default GeneradorOfertaPage;